let triggers = {};
const defaultInitialTriggers = {
  "15DAY": {
    "shortcut": "15DAY",
    "response": "Thanks for visiting uBreakiFix! Your repair comes with our 1-Year Warranty on parts and labor. If you experience any issues, please stop by any of our locations nationwide for assistance.",
    "tags": ["uBreakiFix", "Customer Service", "Warranty"]
  },
  "thx": {
    "shortcut": "thx",
    "response": "Thank you so much for choosing TypeSmart! If you have any questions or feedback, feel free to reach out to our support team.",
    "tags": ["General", "Polite"]
  }
};
const selectedTriggers = new Set();

function updateBatchDeleteButton() {
  const batchBtn = document.getElementById('deleteSelectedBtn');
  if (batchBtn) {
    if (selectedTriggers.size > 0) {
      batchBtn.disabled = false;
      batchBtn.textContent = `Delete (${selectedTriggers.size})`;
    } else {
      batchBtn.disabled = true;
      batchBtn.textContent = 'Delete';
    }
  }

  // Sync Select All Checkbox state with visible cards (checked if any visible card is selected)
  const selectAllCheckbox = document.getElementById('selectAllCheckbox');
  if (selectAllCheckbox) {
    const visibleCardCheckboxes = document.querySelectorAll('.card-select-checkbox:not(#selectAllCheckbox)');
    if (visibleCardCheckboxes.length > 0) {
      const anyChecked = Array.from(visibleCardCheckboxes).some(cb => cb.checked);
      selectAllCheckbox.checked = anyChecked;
    } else {
      selectAllCheckbox.checked = false;
    }
  }
}

function normalizeTriggers(rawTriggers) {
  if (!rawTriggers) return {};
  const cleaned = {};
  for (const key in rawTriggers) {
    if (Object.prototype.hasOwnProperty.call(rawTriggers, key)) {
      const cleanKey = key.startsWith(';') ? key.slice(1) : key;
      cleaned[cleanKey] = rawTriggers[key];
    }
  }
  return cleaned;
}

function matchesSearch(shortcut = '', response = '', tags = [], rawQuery = '') {
  if (!rawQuery || !rawQuery.trim()) return true;

  const query = rawQuery.toLowerCase().trim();
  const cleanQuery = query.replace(/^[;!.]/, '');

  const shortcutLower = (shortcut || '').toLowerCase();
  const responseLower = (response || '').toLowerCase();
  const tagsStr = (Array.isArray(tags) ? tags.join(' ') : '').toLowerCase();

  // 1. Match shortcut (with or without prefix symbol like ; or .)
  if (shortcutLower.includes(query) || (cleanQuery && shortcutLower.includes(cleanQuery))) {
    return true;
  }

  // 2. Match tags
  if (tagsStr.includes(query) || (cleanQuery && tagsStr.includes(cleanQuery))) {
    return true;
  }

  // 3. Match response body (exclude single punctuation marks like '.' or ';' from matching English text)
  const isPunctuationOnly = /^[^a-zA-Z0-9]+$/.test(query);
  if (!isPunctuationOnly && responseLower.includes(query)) {
    return true;
  }

  return false;
}

import { BetterBaseClient } from './betterbase-client.js';

async function updateProfileUI() {
  const session = await BetterBaseClient.getSession();
  const profile = await BetterBaseClient.getUserProfile();

  const dailyExpansionsVal = document.getElementById('dailyExpansionsVal');
  const profileMenuName = document.querySelector('.profile-menu-name');
  const profileMenuEmail = document.querySelector('.profile-menu-email');
  const settingsUserEmail = document.querySelector('.settings-user-email');
  const settingsUserName = document.querySelector('.settings-user-name');

  if (session && session.user) {
    const handle = session.user.email ? session.user.email.split('@')[0] : 'User';
    const tierBadge = profile ? profile.subscription_tier.toUpperCase() : 'FREE';
    if (profileMenuEmail) profileMenuEmail.textContent = session.user.email;
    if (settingsUserEmail) settingsUserEmail.textContent = session.user.email;
    if (profileMenuName) profileMenuName.innerHTML = `${handle} <span class="profile-badge">[${tierBadge}]</span>`;
    if (settingsUserName) settingsUserName.innerHTML = `${handle} <span class="profile-badge">[${tierBadge}]</span>`;
  }

  if (dailyExpansionsVal) {
    const used = profile ? profile.daily_expansions_used : 0;
    const limit = (profile && profile.subscription_tier !== 'free') ? '∞' : '10';
    dailyExpansionsVal.textContent = `${used} / ${limit}`;
  }
}

// Load and save functions
async function loadTriggers() {
  const cloudTriggers = await BetterBaseClient.fetchUserTriggers();
  if (cloudTriggers && Object.keys(cloudTriggers).length > 0) {
    triggers = normalizeTriggers(cloudTriggers);
    renderTriggers();
    checkImportSharedURL();
    await updateProfileUI();
    return;
  }

  if (typeof chrome !== 'undefined' && chrome.storage && chrome.storage.sync) {
    chrome.storage.sync.get(['triggers', 'hasClearedDefaults_v3'], (data) => {
      if (!data.hasClearedDefaults_v3) {
        triggers = {};
        chrome.storage.sync.set({ triggers: {}, hasClearedDefaults_v3: true }, () => {
          renderTriggers();
          checkImportSharedURL();
        });
        return;
      }

      if (data.triggers) {
        triggers = normalizeTriggers(data.triggers);
      } else {
        triggers = {};
      }
      renderTriggers();
      checkImportSharedURL();
    });
  } else {
    try {
      const stored = localStorage.getItem('typesmart_triggers');
      if (stored) {
        triggers = normalizeTriggers(JSON.parse(stored));
      } else {
        triggers = normalizeTriggers(defaultInitialTriggers);
        localStorage.setItem('typesmart_triggers', JSON.stringify(triggers));
      }
    } catch (e) {
      triggers = normalizeTriggers(defaultInitialTriggers);
    }
    renderTriggers();
    checkImportSharedURL();
  }
  await updateProfileUI();
}

async function saveTriggers() {
  if (typeof chrome !== 'undefined' && chrome.storage && chrome.storage.sync) {
    chrome.storage.sync.set({ triggers }, () => {
      if (chrome.tabs && chrome.tabs.query) {
        chrome.tabs.query({}, (tabs) => {
          tabs.forEach((tab) => {
            try { chrome.tabs.sendMessage(tab.id, { action: 'updateTriggers', triggers }); } catch (e) {}
          });
        });
      }
    });
  } else {
    try {
      localStorage.setItem('typesmart_triggers', JSON.stringify(triggers));
    } catch (e) {}
  }

  const session = await BetterBaseClient.getSession();
  if (session && session.user) {
    for (const key in triggers) {
      if (Object.prototype.hasOwnProperty.call(triggers, key)) {
        await BetterBaseClient.saveUserTrigger(triggers[key]);
      }
    }
  }
}

// Function to escape CSV fields containing commas or quotes
function escapeCsvField(field) {
  if (field.includes(",") || field.includes('"')) {
    return `"${field.replace(/"/g, '""')}"`;
  }
  return field;
}

// Export to CSV function
function exportToCsv() {
  let csvContent = "Trigger,Response,Tags,Enabled\n";
  for (const trigger in triggers) {
    const triggerData = triggers[trigger];
    const tags = triggerData.tags ? triggerData.tags.join(';') : '';
    csvContent += `${escapeCsvField(trigger)},${escapeCsvField(triggerData.response)},${escapeCsvField(tags)},${triggerData.enabled}\n`;
  }

  const blob = new Blob([csvContent], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'triggers.csv';
  a.click();
  URL.revokeObjectURL(url);
}

// Import from CSV function
function importFromCsv(event) {
  const file = event.target.files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = (e) => {
    const content = e.target.result;
    const lines = content.split('\n');

    lines.shift(); // Remove header line

    lines.forEach(line => {
      const fields = line.match(/(".*?"|repr\([^)]+\)|[^",\s]+)(?=\s*,|\s*$)/g);
      if (!fields) return;

      const [trigger, response, tags, enabled] = fields.map(field => field.replace(/^"|"$/g, '').trim());

      if (trigger && response) {
        triggers[trigger] = {
          response: response,
          responseHtml: response,
          tags: tags ? tags.split(';').map(tag => tag.trim()) : [],
          enabled: enabled ? enabled.toLowerCase() === 'true' : true
        };
      }
    });

    saveTriggers();
    renderTriggers();
  };

  reader.readAsText(file);
}

// Modal dialog
function createModal() {
  const overlay = document.createElement('div');
  overlay.className = 'modal';

  const modalContent = document.createElement('div');
  modalContent.className = 'modal-content';

  const title = document.createElement('h2');
  title.textContent = 'Add New Expansion Template';
  modalContent.appendChild(title);

  overlay.appendChild(modalContent);
  document.body.appendChild(overlay);

  return { overlay: overlay, content: modalContent };
}

// Add trigger modal
function addTrigger() {
  const modal = createModal();

  const triggerInput = document.createElement('input');
  triggerInput.type = 'text';
  triggerInput.placeholder = 'Trigger shortcut (e.g. RFP or email)';
  modal.content.appendChild(triggerInput);

  const tagsInput = document.createElement('input');
  tagsInput.type = 'text';
  tagsInput.placeholder = 'Tags (comma-separated, e.g. email, work)';
  modal.content.appendChild(tagsInput);

  const responseEditor = document.createElement('div');
  responseEditor.contentEditable = true;
  responseEditor.className = 'formatted-text';
  responseEditor.setAttribute('placeholder', 'Expansion content...');
  modal.content.appendChild(responseEditor);

  const buttonsDiv = document.createElement('div');
  buttonsDiv.className = 'modal-buttons';

  const saveButton = document.createElement('button');
  saveButton.className = 'btn btn-primary';
  saveButton.textContent = 'Save Template';
  saveButton.addEventListener('click', () => {
    const triggerText = triggerInput.value.trim();
    if (!triggerText) {
      alert('Trigger text cannot be empty.');
      return;
    }
    if (triggers[triggerText]) {
      alert('Trigger already exists.');
      return;
    }
    const tags = tagsInput.value.split(',').map(tag => tag.trim()).filter(tag => tag);
    triggers[triggerText] = {
      enabled: true,
      response: responseEditor.innerText,
      responseHtml: responseEditor.innerHTML,
      tags: tags
    };
    saveTriggers();
    renderTriggers();
    document.body.removeChild(modal.overlay);
  });
  buttonsDiv.appendChild(saveButton);

  const cancelButton = document.createElement('button');
  cancelButton.className = 'btn btn-secondary';
  cancelButton.textContent = 'Cancel';
  cancelButton.addEventListener('click', () => {
    document.body.removeChild(modal.overlay);
  });
  buttonsDiv.appendChild(cancelButton);

  modal.content.appendChild(buttonsDiv);
}

// Render triggers list as spacious cards
function renderTriggers(filter = '') {
  const container = document.getElementById('templatesList');
  if (!container) return;
  container.innerHTML = '';

  for (const trigger in triggers) {
    const triggerData = triggers[trigger];

    if (matchesSearch(trigger, triggerData.response, triggerData.tags, filter)) {
      const isSelected = selectedTriggers.has(trigger);
      const card = document.createElement('div');
      card.className = `template-card ${isSelected ? 'selected' : ''}`;

      card.innerHTML = `
        <div class="card-header-row">
          <div class="card-left-info">
            <input type="checkbox" class="card-select-checkbox" data-trigger="${trigger}" ${isSelected ? 'checked' : ''} title="Select template">
            <span class="trigger-pill">${trigger}</span>
          </div>
          <div class="card-right-actions">
            <button class="card-action-btn share-btn" title="Share template">🔗 Share</button>
            <button class="card-action-btn delete-btn" title="Delete template">🗑️ Delete</button>
            <label class="switch" title="Toggle Trigger">
              <input type="checkbox" class="toggle-switch" ${triggerData.enabled ? 'checked' : ''}>
              <span class="slider"></span>
            </label>
          </div>
        </div>

        <div class="card-body-preview" contenteditable="true">${triggerData.responseHtml || triggerData.response}</div>

        <div class="card-footer-row">
          <div class="tags-container">
            <span>🏷️</span>
            ${
              triggerData.tags && triggerData.tags.length > 0
                ? triggerData.tags.map(t => `<span class="tag-badge">${t}</span>`).join('')
                : '<span style="color:#64748b;">No tags</span>'
            }
          </div>
        </div>
      `;

      // Event listeners for card interactions
      const selectCheckbox = card.querySelector('.card-select-checkbox');
      selectCheckbox.addEventListener('change', () => {
        if (selectCheckbox.checked) {
          selectedTriggers.add(trigger);
          card.classList.add('selected');
        } else {
          selectedTriggers.delete(trigger);
          card.classList.remove('selected');
        }
        updateBatchDeleteButton();
      });

      const toggleInput = card.querySelector('.toggle-switch');
      toggleInput.addEventListener('change', () => {
        triggers[trigger].enabled = toggleInput.checked;
        saveTriggers();
      });

      const bodyPreview = card.querySelector('.card-body-preview');
      bodyPreview.addEventListener('blur', () => {
        triggers[trigger].response = bodyPreview.innerText;
        triggers[trigger].responseHtml = bodyPreview.innerHTML;
        saveTriggers();
      });

      const shareBtn = card.querySelector('.share-btn');
      shareBtn.addEventListener('click', () => {
        openShareModal({ [trigger]: triggers[trigger] }, trigger);
      });

      const deleteBtn = card.querySelector('.delete-btn');
      deleteBtn.addEventListener('click', () => {
        if (confirm(`Are you sure you want to delete "${trigger}"?`)) {
          delete triggers[trigger];
          selectedTriggers.delete(trigger);
          saveTriggers();
          updateBatchDeleteButton();
          renderTriggers(filter);
        }
      });

      container.appendChild(card);
    }
  }

  updateBatchDeleteButton();

  if (container.children.length === 0) {
    if (filter) {
      container.innerHTML = `
        <div style="text-align: center; color: #94a3b8; padding: 40px; background: #141724; border-radius: 16px; border: 1px dashed rgba(255,255,255,0.1);">
          No templates found matching "${filter}".
        </div>
      `;
    } else {
      container.innerHTML = `
        <div style="text-align: center; color: #94a3b8; padding: 40px 20px; background: #141724; border-radius: 16px; border: 1px dashed rgba(157, 255, 0, 0.25);">
          <div style="font-size: 32px; margin-bottom: 12px;">📋</div>
          <div style="font-size: 16px; font-weight: 700; color: #ffffff; margin-bottom: 6px;">Your account has no saved templates yet</div>
          <div style="font-size: 13px; color: #94a3b8; max-width: 440px; margin: 0 auto;">
            Click <strong>"uBreakiFix"</strong> under ORGANIZATIONS on the left sidebar to browse <strong>89 Organization Templates</strong> and click <strong>"➕ Add to my account"</strong> to save templates to your personal collection.
          </div>
        </div>
      `;
    }
  }
}

// Tab navigation listeners
const tabTemplates = document.getElementById('tabTemplates');
const tabAutomations = document.getElementById('tabAutomations');
if (tabTemplates && tabAutomations) {
  tabTemplates.addEventListener('click', () => {
    tabTemplates.classList.add('active');
    tabAutomations.classList.remove('active');
    renderTriggers();
  });
  tabAutomations.addEventListener('click', () => {
    tabAutomations.classList.add('active');
    tabTemplates.classList.remove('active');
    const container = document.getElementById('templatesList');
    if (container) {
      container.innerHTML = `
        <div style="text-align: center; color: #94a3b8; padding: 40px; background: #141724; border-radius: 16px; border: 1px dashed rgba(255,255,255,0.1);">
          No active automations yet. Create your first workflow automation.
        </div>
      `;
    }
  });
}

// Event listeners for Import and Export buttons
document.getElementById('exportCsv')?.addEventListener('click', exportToCsv);
document.getElementById('importCsv')?.addEventListener('change', importFromCsv);

function downloadLimeIcons() {
  const sizes = [16, 32, 48, 128];
  sizes.forEach((size, idx) => {
    setTimeout(() => {
      const canvas = document.createElement('canvas');
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext('2d');

      const radius = size * 0.22;
      ctx.fillStyle = '#8BE600';
      ctx.beginPath();
      ctx.roundRect(0, 0, size, size, radius);
      ctx.fill();

      ctx.fillStyle = '#090A0F';
      ctx.beginPath();
      const poly = [
        [0.55, 0.15],
        [0.32, 0.50],
        [0.50, 0.50],
        [0.44, 0.85],
        [0.68, 0.46],
        [0.50, 0.46]
      ];
      poly.forEach(([x, y], i) => {
        if (i === 0) ctx.moveTo(x * size, y * size);
        else ctx.lineTo(x * size, y * size);
      });
      ctx.closePath();
      ctx.fill();

      const a = document.createElement('a');
      a.href = canvas.toDataURL('image/png');
      a.download = `icon${size}.png`;
      a.click();
    }, idx * 250);
  });
}

const downloadIconsBtn = document.getElementById('downloadIconsBtn');
if (downloadIconsBtn) {
  downloadIconsBtn.addEventListener('click', (e) => {
    e.preventDefault();
    downloadLimeIcons();
  });
}

// Initial event listeners for add trigger and search input
document.getElementById('addTrigger')?.addEventListener('click', addTrigger);
document.getElementById('searchInput')?.addEventListener('input', (e) => {
  renderTriggers(e.target.value);
});

// Profile Context Menu Logic
const profileBtn = document.getElementById('profileBtn');
const profileContextMenu = document.getElementById('profileContextMenu');

if (profileBtn && profileContextMenu) {
  profileBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    helpContextMenu?.classList.remove('show');
    profileContextMenu.classList.toggle('show');
  });

  document.addEventListener('click', (e) => {
    if (!profileContextMenu.contains(e.target) && e.target !== profileBtn) {
      profileContextMenu.classList.remove('show');
    }
  });

  document.getElementById('menuPersonalSettings')?.addEventListener('click', () => {
    profileContextMenu.classList.remove('show');
    switchView('personal_settings');
  });

  document.getElementById('menuBilling')?.addEventListener('click', () => {
    profileContextMenu.classList.remove('show');
    openBillingModal();
  });

  document.getElementById('menuImportTemplates')?.addEventListener('click', () => {
    profileContextMenu.classList.remove('show');
    document.getElementById('importCsv')?.click();
  });

  document.getElementById('menuExportTemplates')?.addEventListener('click', () => {
    profileContextMenu.classList.remove('show');
    exportToCsv();
  });

  document.getElementById('menuSignOut')?.addEventListener('click', () => {
    profileContextMenu.classList.remove('show');
    if (confirm('Are you sure you want to sign out?')) {
      alert('You have signed out of TypeSmart.');
      window.location.href = 'login.html';
    }
  });
}

// Help Context Menu Logic
const helpBtn = document.getElementById('helpBtn');
const helpContextMenu = document.getElementById('helpContextMenu');

if (helpBtn && helpContextMenu) {
  helpBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    profileContextMenu?.classList.remove('show');
    helpContextMenu.classList.toggle('show');
  });

  document.addEventListener('click', (e) => {
    if (!helpContextMenu.contains(e.target) && e.target !== helpBtn) {
      helpContextMenu.classList.remove('show');
    }
  });

  document.getElementById('menuGetSupport')?.addEventListener('click', () => {
    helpContextMenu.classList.remove('show');
    alert('TypeSmart Support: Reach out to support@typesmart.io or visit our help center.');
  });

  document.getElementById('menuFeedback')?.addEventListener('click', () => {
    helpContextMenu.classList.remove('show');
    const feedbackText = prompt('We value your feedback! Tell us how we can improve TypeSmart:');
    if (feedbackText) {
      alert('Thank you for your feedback!');
    }
  });
}

// Batch Delete Selected Templates Logic
const deleteSelectedBtn = document.getElementById('deleteSelectedBtn');
if (deleteSelectedBtn) {
  deleteSelectedBtn.addEventListener('click', () => {
    if (selectedTriggers.size === 0) return;
    const count = selectedTriggers.size;
    if (confirm(`Are you sure you want to delete ${count} selected template(s)?`)) {
      selectedTriggers.forEach((trig) => {
        delete triggers[trig];
      });
      selectedTriggers.clear();
      saveTriggers();
      updateBatchDeleteButton();
      renderTriggers(document.getElementById('searchInput')?.value || '');
    }
  });
}

// Select All / Deselect All Master Checkbox Logic
const selectAllCheckbox = document.getElementById('selectAllCheckbox');
if (selectAllCheckbox) {
  selectAllCheckbox.addEventListener('click', (e) => {
    const visibleCards = document.querySelectorAll('.template-card');
    const visibleCheckboxes = Array.from(document.querySelectorAll('.card-select-checkbox:not(#selectAllCheckbox)'));
    const anyChecked = visibleCheckboxes.some(cb => cb.checked);

    const shouldSelectAll = !anyChecked;

    visibleCards.forEach(card => {
      const cb = card.querySelector('.card-select-checkbox');
      const trigger = cb?.getAttribute('data-trigger');
      if (trigger && cb) {
        cb.checked = shouldSelectAll;
        if (shouldSelectAll) {
          selectedTriggers.add(trigger);
          card.classList.add('selected');
        } else {
          selectedTriggers.delete(trigger);
          card.classList.remove('selected');
        }
      }
    });

    selectAllCheckbox.checked = shouldSelectAll;
    updateBatchDeleteButton();
  });
}

// Share Modal Management
let currentTemplatesToShare = {};

function openShareModal(templatesObj, labelSubtitle = '') {
  currentTemplatesToShare = templatesObj || {};
  const keys = Object.keys(currentTemplatesToShare);
  const count = keys.length;

  const modalTitle = document.getElementById('shareModalTitle');
  const modalSubtitle = document.getElementById('shareModalSubtitle');
  const modalOverlay = document.getElementById('shareModalOverlay');

  if (count === 1) {
    if (modalTitle) modalTitle.textContent = 'Share 1 template';
    if (modalSubtitle) modalSubtitle.textContent = labelSubtitle || keys[0];
  } else {
    if (modalTitle) modalTitle.textContent = `Share ${count} templates`;
    if (modalSubtitle) modalSubtitle.textContent = labelSubtitle || `${count} selected shortcuts`;
  }

  const toInput = document.getElementById('shareToInput');
  const msgInput = document.getElementById('shareMessageInput');
  if (toInput) toInput.value = '';
  if (msgInput) msgInput.value = '';

  modalOverlay?.classList.add('show');
}

function closeShareModal() {
  document.getElementById('shareModalOverlay')?.classList.remove('show');
}

document.getElementById('closeShareModalBtn')?.addEventListener('click', closeShareModal);
document.getElementById('shareModalOverlay')?.addEventListener('click', (e) => {
  if (e.target.id === 'shareModalOverlay') closeShareModal();
});

document.getElementById('sendShareEmailBtn')?.addEventListener('click', async () => {
  const sendBtn = document.getElementById('sendShareEmailBtn');
  const recipient = document.getElementById('shareToInput')?.value.trim() || '';
  const message = document.getElementById('shareMessageInput')?.value.trim() || '';

  if (!recipient) {
    alert('Please enter at least one recipient email address.');
    return;
  }

  const originalText = sendBtn.textContent;
  sendBtn.style.background = '#22c55e';
  sendBtn.style.borderColor = '#22c55e';
  sendBtn.style.color = '#ffffff';
  sendBtn.textContent = '✓ Sent';
  sendBtn.disabled = true;

  const payloadStr = btoa(encodeURIComponent(JSON.stringify(currentTemplatesToShare)));
  const shareUrl = `https://www.typesmart.io/share.html?importShared=${payloadStr}&author=itsKayWat`;

  try {
    await fetch('http://localhost:8005/api/send-share-email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        to: recipient,
        author: 'itsKayWat',
        message: message,
        templates: currentTemplatesToShare,
        shareUrl: shareUrl
      })
    });
  } catch (err) {
    console.warn('API email notification notice:', err);
  }

  setTimeout(() => {
    closeShareModal();
    sendBtn.style.background = '';
    sendBtn.style.borderColor = '';
    sendBtn.style.color = '';
    sendBtn.textContent = originalText;
    sendBtn.disabled = false;
  }, 1200);
});

document.getElementById('copyShareLinkBtn')?.addEventListener('click', () => {
  const payloadStr = btoa(encodeURIComponent(JSON.stringify(currentTemplatesToShare)));
  const shareUrl = `https://www.typesmart.io/share.html?importShared=${payloadStr}&author=itsKayWat`;

  navigator.clipboard.writeText(shareUrl).then(() => {
    alert('Share link copied to clipboard!\n\nLink:\n' + shareUrl);
  }).catch(() => {
    prompt('Copy this share link:', shareUrl);
  });
  closeShareModal();
});

document.getElementById('btnShare')?.addEventListener('click', () => {
  if (selectedTriggers.size > 0) {
    const selectedObj = {};
    selectedTriggers.forEach(trig => {
      if (triggers[trig]) selectedObj[trig] = triggers[trig];
    });
    openShareModal(selectedObj, `${selectedTriggers.size} selected templates`);
  } else {
    openShareModal(triggers, 'All workspace templates');
  }
});

let pendingImportPayload = null;

function checkImportSharedURL() {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('importShared')) {
    try {
      const rawPayload = urlParams.get('importShared');
      const author = urlParams.get('author') || 'itsKayWat';
      const decodedJson = decodeURIComponent(atob(rawPayload));
      const parsedData = JSON.parse(decodedJson);

      if (parsedData && typeof parsedData === 'object' && Object.keys(parsedData).length > 0) {
        pendingImportPayload = parsedData;
        const count = Object.keys(parsedData).length;

        const importTitle = document.getElementById('importModalTitle');
        const importCount = document.getElementById('importModalCount');
        const importOverlay = document.getElementById('importSharedModalOverlay');

        if (importTitle) importTitle.textContent = `${author} crafted a productivity gift for you!`;
        if (importCount) importCount.textContent = `${count} template${count > 1 ? 's' : ''}`;

        importOverlay?.classList.add('show');
      }
    } catch (err) {
      console.error('Failed to parse importShared parameter:', err);
    }
  }
}

function closeImportModal() {
  document.getElementById('importSharedModalOverlay')?.classList.remove('show');
  window.history.replaceState({}, document.title, window.location.pathname);
}

document.getElementById('closeImportModalBtn')?.addEventListener('click', closeImportModal);
document.getElementById('importSharedModalOverlay')?.addEventListener('click', (e) => {
  if (e.target.id === 'importSharedModalOverlay') closeImportModal();
});

document.getElementById('confirmImportSharedBtn')?.addEventListener('click', () => {
  if (pendingImportPayload) {
    const count = Object.keys(pendingImportPayload).length;
    for (const key in pendingImportPayload) {
      triggers[key] = pendingImportPayload[key];
    }
    saveTriggers();
    renderTriggers();
    alert(`Successfully added ${count} template(s) to your collection!`);
  }
  closeImportModal();
});

function switchView(viewName) {
  const homeView = document.getElementById('templatesHomeView');
  const settingsView = document.getElementById('personalSettingsView');
  const ubreakifixView = document.getElementById('ubreakifixOrgView');
  const rightHeader = document.querySelector('.right-sidebar .right-header');
  const navHomeBtn = document.getElementById('navHomeBtn');
  const navOrgBtn = document.getElementById('navOrgUbreakifixBtn');

  if (homeView) homeView.style.display = 'none';
  if (settingsView) settingsView.style.display = 'none';
  if (ubreakifixView) ubreakifixView.style.display = 'none';

  if (navHomeBtn) navHomeBtn.classList.remove('active');
  if (navOrgBtn) navOrgBtn.classList.remove('active');

  if (viewName === 'personal_settings') {
    if (settingsView) settingsView.style.display = 'flex';
    if (rightHeader) {
      rightHeader.innerHTML = `
        <h2>⚙️ Settings</h2>
        <p>Adjust preferences for yourself.</p>
      `;
    }
  } else if (viewName === 'ubreakifix') {
    if (ubreakifixView) ubreakifixView.style.display = 'flex';
    if (navOrgBtn) navOrgBtn.classList.add('active');
    renderOrgTemplates();
    if (rightHeader) {
      rightHeader.innerHTML = `
        <div class="org-info-strip" style="margin-bottom: 16px;">
          <span>💡 Click <strong>"➕ Add to my account"</strong> on any template below to save it directly to your personal shortcut collection.</span>
        </div>
        <h2>🏢 uBreakiFix</h2>
        <p>Verified templates and automations for uBreakiFix repair technicians.</p>
        <button class="btn btn-secondary" id="btnJoinUbreakifix" style="background: rgba(157, 255, 0, 0.12); color: #9dff00; border-color: rgba(157, 255, 0, 0.35); font-weight: 800; padding: 8px 16px; font-size: 13px; cursor: pointer; border-radius: 20px; margin-top: 12px; display: inline-flex; align-items: center; gap: 6px;">🤝 Apply to Join</button>
      `;
      document.getElementById('btnJoinUbreakifix')?.addEventListener('click', () => {
        openJoinOrgModal('uBreakiFix');
      });
    }
  } else {
    if (homeView) homeView.style.display = 'flex';
    if (navHomeBtn) navHomeBtn.classList.add('active');
    if (rightHeader) {
      rightHeader.innerHTML = `
        <h2>🏠 Home</h2>
        <p>All automations and templates, both personal and shared with you.</p>
      `;
    }
  }
}

function checkUrlViewParam() {
  const urlParams = new URLSearchParams(window.location.search);
  const view = urlParams.get('view');
  if (view === 'personal_settings') {
    switchView('personal_settings');
  } else if (view === 'ubreakifix') {
    switchView('ubreakifix');
  } else if (view === 'submit_org') {
    openSubmitOrgModal();
  } else if (view === 'join_org') {
    openJoinOrgModal();
  }
}

function loadPersonalSettings() {
  if (typeof chrome !== 'undefined' && chrome.storage && chrome.storage.sync) {
    chrome.storage.sync.get(['triggerOnSpace', 'triggerShortcut', 'autosuggestEnabled', 'showOverlay'], (data) => {
      const triggerOnSpace = typeof data.triggerOnSpace === 'boolean' ? data.triggerOnSpace : false;
      const triggerShortcut = data.triggerShortcut || '//';
      const autosuggestEnabled = typeof data.autosuggestEnabled === 'boolean' ? data.autosuggestEnabled : true;
      const showOverlay = typeof data.showOverlay === 'boolean' ? data.showOverlay : true;

      const spaceCb = document.getElementById('settingTriggerOnSpace');
      if (spaceCb) spaceCb.checked = triggerOnSpace;

      const shortcutInput = document.getElementById('settingShortcutInput');
      if (shortcutInput) shortcutInput.value = triggerShortcut;

      const autoCb = document.getElementById('settingAutosuggest');
      if (autoCb) autoCb.checked = autosuggestEnabled;

      const overlayCb = document.getElementById('settingShowOverlay');
      if (overlayCb) overlayCb.checked = showOverlay;
    });
  } else {
    try {
      const storedSpace = localStorage.getItem('typesmart_triggerOnSpace');
      const storedShortcut = localStorage.getItem('typesmart_triggerShortcut');
      const storedAuto = localStorage.getItem('typesmart_autosuggestEnabled');
      const storedOverlay = localStorage.getItem('typesmart_showOverlay');

      const spaceCb = document.getElementById('settingTriggerOnSpace');
      if (spaceCb) spaceCb.checked = storedSpace === 'true';

      const shortcutInput = document.getElementById('settingShortcutInput');
      if (shortcutInput) shortcutInput.value = storedShortcut || '//';

      const autoCb = document.getElementById('settingAutosuggest');
      if (autoCb) autoCb.checked = storedAuto !== 'false';

      const overlayCb = document.getElementById('settingShowOverlay');
      if (overlayCb) overlayCb.checked = storedOverlay !== 'false';
    } catch (e) {}
  }
}

function savePersonalSettings() {
  const spaceCb = document.getElementById('settingTriggerOnSpace');
  const shortcutInput = document.getElementById('settingShortcutInput');
  const autoCb = document.getElementById('settingAutosuggest');
  const overlayCb = document.getElementById('settingShowOverlay');

  const triggerOnSpace = spaceCb ? spaceCb.checked : false;
  const triggerShortcut = shortcutInput ? shortcutInput.value.trim() : '//';
  const autosuggestEnabled = autoCb ? autoCb.checked : true;
  const showOverlay = overlayCb ? overlayCb.checked : true;

  if (typeof chrome !== 'undefined' && chrome.storage && chrome.storage.sync) {
    chrome.storage.sync.set({ triggerOnSpace, triggerShortcut, autosuggestEnabled, showOverlay }, () => {
      if (chrome.tabs && chrome.tabs.query) {
        chrome.tabs.query({}, (tabs) => {
          tabs.forEach((tab) => {
            chrome.tabs.sendMessage(tab.id, {
              action: 'updateSettings',
              triggerOnSpace,
              triggerShortcut,
              autosuggestEnabled,
              showOverlay
            }).catch(() => {});
          });
        });
      }
      if (typeof chrome !== 'undefined' && chrome.storage && chrome.storage.local) {
        chrome.storage.local.set({ ste_fab_hidden: !showOverlay });
      }

      const saveBtn = document.getElementById('btnSavePersonalSettings');
      if (saveBtn) {
        const originalText = saveBtn.textContent;
        saveBtn.textContent = '✓ Saved';
        saveBtn.style.background = '#22c55e';
        setTimeout(() => {
          saveBtn.textContent = originalText;
          saveBtn.style.background = '';
          switchView('home');
        }, 800);
      } else {
        switchView('home');
      }
    });
  } else {
    try {
      localStorage.setItem('typesmart_triggerOnSpace', triggerOnSpace);
      localStorage.setItem('typesmart_triggerShortcut', triggerShortcut);
      localStorage.setItem('typesmart_autosuggestEnabled', autosuggestEnabled);
      localStorage.setItem('typesmart_showOverlay', showOverlay);
    } catch (e) {}

    const saveBtn = document.getElementById('btnSavePersonalSettings');
    if (saveBtn) {
      const originalText = saveBtn.textContent;
      saveBtn.textContent = '✓ Saved';
      saveBtn.style.background = '#22c55e';
      setTimeout(() => {
        saveBtn.textContent = originalText;
        saveBtn.style.background = '';
        switchView('home');
      }, 800);
    } else {
      switchView('home');
    }
  }
}

document.getElementById('btnSavePersonalSettings')?.addEventListener('click', savePersonalSettings);
document.getElementById('btnCancelPersonalSettings')?.addEventListener('click', () => switchView('home'));

document.getElementById('btnChangeEmail')?.addEventListener('click', () => {
  const newEmail = prompt('Enter your new email address:', 'itskaywat@gmail.com');
  if (newEmail) {
    alert(`Verification email sent to ${newEmail}. Please confirm to complete the update.`);
  }
});

document.getElementById('btnDeleteAccount')?.addEventListener('click', () => {
  if (confirm('Are you sure you want to delete your account? This action cannot be undone.')) {
    alert('Account deletion request submitted. Support will contact you shortly.');
  }
});

function openBillingModal() {
  const billingOverlay = document.getElementById('billingModalOverlay');
  if (billingOverlay) {
    billingOverlay.classList.add('show');
  }
}

function closeBillingModal() {
  document.getElementById('billingModalOverlay')?.classList.remove('show');
}

function openUpgradeModal() {
  closeBillingModal();
  const upgradeOverlay = document.getElementById('upgradeModalOverlay');
  if (upgradeOverlay) {
    const pricingToggle = document.getElementById('pricingBillingToggle');
    if (pricingToggle) {
      pricingToggle.checked = true;
      updatePricingDisplay(true);
    }
    upgradeOverlay.classList.add('show');
  }
}

function closeUpgradeModal() {
  document.getElementById('upgradeModalOverlay')?.classList.remove('show');
}

function updatePricingDisplay(isAnnual) {
  const amountVal = document.getElementById('pricingAmountVal');
  const labelAnnual = document.getElementById('labelAnnual');
  const labelMonthly = document.getElementById('labelMonthly');

  if (isAnnual) {
    if (amountVal) amountVal.textContent = '$3.25';
    if (labelAnnual) labelAnnual.classList.add('active');
    if (labelMonthly) labelMonthly.classList.remove('active');
  } else {
    if (amountVal) amountVal.textContent = '$3.99';
    if (labelMonthly) labelMonthly.classList.add('active');
    if (labelAnnual) labelAnnual.classList.remove('active');
  }
}

document.getElementById('pricingBillingToggle')?.addEventListener('change', (e) => {
  updatePricingDisplay(e.target.checked);
});

document.getElementById('closeBillingModalBtn')?.addEventListener('click', closeBillingModal);
document.getElementById('billingModalOverlay')?.addEventListener('click', (e) => {
  if (e.target.id === 'billingModalOverlay') closeBillingModal();
});

document.getElementById('closeUpgradeModalBtn')?.addEventListener('click', closeUpgradeModal);
document.getElementById('upgradeModalOverlay')?.addEventListener('click', (e) => {
  if (e.target.id === 'upgradeModalOverlay') closeUpgradeModal();
});

document.getElementById('billingUpgradeBannerBtn')?.addEventListener('click', openUpgradeModal);
document.getElementById('btnUpgrade')?.addEventListener('click', openUpgradeModal);

document.getElementById('btnConfirmUpgradePlan')?.addEventListener('click', () => {
  const isAnnual = document.getElementById('pricingBillingToggle')?.checked ?? true;
  const planType = isAnnual ? 'Core Annual ($3.25/mo)' : 'Core Monthly ($3.99/mo)';
  alert(`Redirecting to Secure Stripe Checkout for TypeSmart ${planType}...`);
  closeUpgradeModal();
});

loadTriggers();
loadPersonalSettings();
checkUrlViewParam();

const ubreakifixTemplates = [
  {
    shortcut: '15DAY',
    response: 'Original Work Order:\n\nIMEI:\n\nAged Work Order Suspension Notice\n\nThe work order has reached the 15-day aged work order policy threshold. Marking as awaiting customer approval for repair.\nAs per location policy, work on this order is suspended until customer approval is received for the repair or all parts have been sourced and received.\nDiagnostics and repair labor paid for, and any amounts due from the customer have been notated on the suspended work order lead/quote.',
    tags: ['Aged Work Order', 'Policy', 'Suspension']
  },
  {
    shortcut: 'ctl',
    response: 'Original Work Order:\n\nIMEI:\n\n- Payment was taken\n- Out of Pocket Work Order\n- Suspending work order until  (  "customer approves repair"  )\n\n\nWork Order is currently awaiting next steps and is aged beyond a week since last update.\n\nAs a result, for queue control, the work order is being closed out, and the work order status has been marked as declined rfp to maintain accurate record-keeping of ongoing active work orders\n\nconverting work order to lead - adjusting line items for amount paid for due',
    tags: ['Queue Control', 'Aged Work Order', 'Status Update']
  },
  {
    shortcut: 'multi_peril',
    response: ' - Multi-Peril? Y',
    tags: ['Multi-Peril', 'Insurance', 'Diagnostics']
  },
  {
    shortcut: 'mp',
    response: 'Missed punch, Manually Punched for Employee (Reviewed Cameras)',
    tags: ['Timecard', 'Payroll', 'Management']
  },
  {
    shortcut: 'por',
    response: 'Subject: Request for Assistance with Inventory Discrepancies\n\nHi Support Team,\n\nI am reaching out regarding our recent order, as we have come across discrepancies with the received items. We are currently unable to scan the following products into our inventory and are looking to have these items added to our inventory as received to accurately reflect the items received on this purchase order:\n\nBattery Disassembly Vacuum, GH81-12712S - Received 2\n\nSamsung SVC JIG-BONDING REMOVAL TOOL, GH81-23171A - Received 4\n\nDisassembly Jig, GH81-20861A - Received 1\n\nSamsung JIG-OPENNING PEAK, Black, GH81-20863A - Received 20\n\nWe kindly request your assistance in resolving these discrepancies and ensuring that our inventory accurately reflects the items received. Your attention to this matter is highly valued.\n\nThank you for your cooperation, and we appreciate your support in addressing this issue promptly.\n\nWarm regards,\nChris Loetz',
    tags: ['Inventory', 'Purchase Order', 'Discrepancy']
  },
  {
    shortcut: 'urej',
    response: 'Device Unavailable In Store - UROC - work order aged, device not present. Closing work order, marking as declined RFP due to customer opting for alternate solutions.\n\nLead:',
    tags: ['UROC', 'Device Unavailable', 'Status Update']
  },
  {
    shortcut: 'spoqc',
    response: 'I am writing to request an exception for the Galaxy Diagnostic OQC test. \n\nThe device under this work order has been successfully repaired and has passed manual outgoing quality control inspection. However, I am currently unable to complete the OQC via Galaxy Diagnostics tool due to technical difficulties.\n\nI would like to assure you that the device is functioning properly and meets all quality standards set by our company. In order to prevent any further delays for our customer, I kindly request an exception to proceed without further delays to the repair for this device allowing the completion of the work order sale. \n\nFenrir has been successfully completed, and a screenshot has been attached to this Sprinklr ticket showing both the Fenrir Test completion and the work order for the customer ',
    tags: ['Galaxy Diagnostics', 'OQC Exception', 'Samsung', 'Fenrir']
  },
  {
    shortcut: 'file',
    response: ' - #R',
    tags: ['File Tag', 'Reference', 'Work Order']
  },
  {
    shortcut: 'legal',
    response: ' - #L',
    tags: ['Legal Tag', 'Reference', 'Work Order']
  },
  {
    shortcut: 'question',
    response: ' - #Q',
    tags: ['Question Tag', 'Reference', 'Work Order']
  },
  {
    shortcut: 'urocwo',
    response: 'Auditing work orders and I identified an aged work order that has not been repaired yet. It needs to be escalated to UROC Level-3 Repair.\n\nI have designated the work order for UROC Repair and generated a label for the device to be sent out to UROC. I am currently packaging the device and placing it in the designated Awaiting Shipment Orange Taped location in the store for UPS to pick up.\n\nTeam, please ensure UPS picks up this device when they drop off their packages and have it shipped out as soon as possible.',
    tags: ['UROC', 'Work Order Audit', 'Shipment', 'Level-3 Repair']
  },
  {
    shortcut: 'aiw',
    response: 'Samsung Galaxy S22 Ultra 5G\n-  Verify that the device marked for screen repair is not in store.\n\n- Call the customer to discuss their preference for proceeding with the repair and to confirm the availability of the necessary part.\n\n- If the customer chooses an alternative solution, close the work order as "declined RFP\n\n- If the customer does not answer the call, make a total of 3 attempts on different dates and document each call in the work order.\n\n- Reschedule the diagnostic repair appointment for the next day if the customer is initially unreachable.\n\n- After the 3rd attempt, if the customer remains unreachable, close the work order as "declined RFP" due to the age of the work order and the customer\'s decision to pursue an alternative solution.   \n\n\n\nhttps://portal.ubif.net/pos/checkout-new/25829115',
    tags: ['Aged Work Order', 'Customer Contact', 'SOP', 'RFP']
  },
  {
    shortcut: 'npctl',
    response: 'Original Work Order:\n\nIMEI:\n\n- No payment was taken for diagnostic\n- Out of Pocket Work Order\n- Suspending work order until Diagnostic payment is received\n\n\nWork Order is currently awaiting next steps and is aged.\n\nAs a result, for queue control, the work order is being closed out, and the work order status has been marked as declined rfp to maintain accurate record-keeping of ongoing active work orders\n\nconverting work order to lead - adjusting line items for amount paid for due',
    tags: ['Queue Control', 'No Payment', 'Aged Work Order', 'Status Update']
  },
  {
    shortcut: 'updateteam',
    response: 'I am following up on this aged work order:\n@jeremy.woody - @joseph.green - @camery.barnett\n\n\n\nHere\'s the workflow I need from you:\n\n\nIdentify if the device is still in-store as it is marked that it is on their WO in Portal\n\nEvaluate the device\n\nIdentify the specific device type, color and model and append the required part to the work order\n\nProvide a comprehensive breakdown of the diagnostic work completed in the notes so we can provide it to the customer, including the tasks and efforts expended up to this point\n\nMark the work order the proper status "Need to Order Parts" or "Awaiting Parts"\n\nIf the part is outsourced, attach it the link to the notes\n\n\n\nYour prompt attention to these tasks will expedite the resolution of the aged work order maintenance issue and ensure transparency in explaining the diagnostic labor charge to relevant parties.',
    tags: ['Team Followup', 'Work Order Audit', 'Diagnostic Breakdown', 'Technician Workflow']
  },
  {
    shortcut: 'urfp',
    response: 'After a succussfully reassembling the phone the phone was still having issues with the display, the display still was not switching from the outer glass to the inner glass - the flex cable is suspected to be the issue - we will need to order the flex cable but the customer is not able to wait - due to the customer not being able to wait, we are marking the work order as unrepairable rfp',
    tags: ['Unrepairable', 'Display Issue', 'Foldable', 'RFP']
  },
  {
    shortcut: 'ann',
    response: 'Canceling Appointment as no Information is in the notes\n- is there a work order?\n- what device are we expecting to work on?\n- What is the repair going to be?\n- Is the device in store?\n\n\nPlease provide the following notes for the appointment system to verify the customer\'s identity before their visit and prepare for their repair, expediting the process.  ',
    tags: ['Appointment', 'Cancellation', 'Missing Notes', 'System Audit']
  },
  {
    shortcut: 'rteam',
    response: '@jeremy.woody - @joseph.green\n\n\n\n Team Update on Work Order:  \n\n Subject: Refund Decision for Work Order #: \n\nAfter careful consideration of Work Order #: XXXXXX, we have decided to refund $XX.xx to the customer due to an unsuccessful repair, aiming to ensure customer satisfaction.\n\nDespite our efforts, the device did not function following the battery replacement, prompting the need for further reimbursement. It is important to prioritize customer satisfaction in this situation.\n\n\n\nThank you for your attention to this, and please proceed and update the customer and process the Cash Refund Payment accordingly when she is in the store being sure to notate on this work order notes when its been completed\n\n\nQuick Sale for Cash Refund:\n\n\n\nBest,\n\nChris Loetz\n\nStore Manager ',
    tags: ['Refund', 'Management', 'Team Update', 'Cash Refund']
  },
  {
    shortcut: 'dteam',
    response: '@jeremy.woody - @joseph.green\n\n\n\nTeam Update on Work Order:  \n\nAfter investigating the customer\'s concern, we have concluded that the diagnostic labor fee is nonrefundable; this charge is allocated for our technicians\' time to diagnose the issue with the device. The diagnostic process was completed, resulting in a part being identified in the notes and subsequently purchased the next day. Please update the customer on this information and reassure them that if they opt for a repair to address the same problem in the future, the diagnostic labor fee will be credited towards the repair, provided it pertains to the initial diagnosis on the same device.  ',
    tags: ['Nonrefundable', 'Diagnostic Fee', 'Management', 'Policy']
  },
  {
    shortcut: 'wof',
    response: 'I am following up on this aged work order:\n@jeremy.woody - @joseph.green\n\n\n\nHere\'s the workflow I need from you:\n\n\nIdentify if the device is still in-store as it is marked that it is on their WO in Portal\n\nEvaluate the device\n\nIdentify the specific device type, color and model and append the required part to the work order\n\nProvide a comprehensive breakdown of the diagnostic work completed in the notes so we can provide it to the customer, including the tasks and efforts expended up to this point\n\nMark the work order the proper status "Need to Order Parts" or "Awaiting Parts"\n\nIf the part is outsourced, attach it the link to the notes\n\n\n\nYour prompt attention to these tasks will expedite the resolution of the aged work order maintenance issue and ensure transparency in explaining the diagnostic labor charge to relevant parties.',
    tags: ['Work Order Followup', 'Audit', 'Technician Workflow']
  },
  {
    shortcut: 'fteam',
    response: '@jeremy.woody - @joseph.green - @r.zheng\n\n\n\n Team Update on Work Order:\n\nI am currently conducting work order audits and in the process of ordering parts for work orders. However, I am uncertain about the specific part needed for this work order specifically, where to place the order, whether the part has already been ordered, or the status of this process. I am tagging Ryan to determine if the part has been ordered or if he has any information on it. If the part has indeed been ordered and confirmed, kindly make a note of it and update the work order status to "Awaiting Parts" ',
    tags: ['Parts Order', 'Audit', 'Team Tag', 'Awaiting Parts']
  },
  {
    shortcut: 'ndap',
    response: 'Parts for this work order have been attempted to be purchased - estimated timeframe for shipping is UPS Next Day Air Saver - update customer when parts are received - moving work order to "Awaiting Parts"\n\n\n\n\n\n\nOrder Details\n\nOrder ID: # \n\nDate Added: ',
    tags: ['UPS Next Day Air', 'Awaiting Parts', 'Part Order', 'Order Details']
  },
  {
    shortcut: 'team',
    response: '@jeremy.woody - @joseph.green - @camery.barnett\n\n Team Update on Work Order:   \n\n',
    tags: ['Team Update', 'Work Order', 'Team Tag']
  },
  {
    shortcut: 'jeremy',
    response: '@jeremy.woody\n\nPlease verify if the part I have ordered is correct. If it is incorrect, kindly inform me of the part that needs to be acquired for the repair.  ',
    tags: ['Part Verification', 'Technician Inquiry', 'Jeremy Woody', 'Work Order']
  },
  {
    shortcut: 'joe',
    response: '@joseph.green\n\nPlease verify if the part I have ordered is correct. If it is incorrect, kindly inform me of the part that needs to be acquired for the repair.  ',
    tags: ['Part Verification', 'Technician Inquiry', 'Joseph Green', 'Work Order']
  },
  {
    shortcut: 'chris',
    response: '@c.loetz',
    tags: ['Store Manager', 'Staff Tag', 'Reference', 'Chris Loetz']
  },
  {
    shortcut: 'callback',
    response: '@gainesvillega\n\nCustomer called for a update, Please contact the customer and update them on the status of your diagnosis results on their current device work order repair.\n\nThank you',
    tags: ['Callback', 'Customer Update', 'Gainesville GA', 'Diagnostic']
  },
  {
    shortcut: 'rej',
    response: 'Device Unavailable In Store - Asurion Support contacted; work order aged, device not present. Closing work order, marking as declined RFP due to customer opting for alternate solutions.',
    tags: ['Asurion', 'Device Unavailable', 'Aged Work Order', 'RFP']
  },
  {
    shortcut: 'eact',
    response: 'Good Afternoon, \n\nThank you for the update and for bringing this forward to my attention. I have reviewed and addressed the pending aged work orders. Based on discussions with both of my newly hired technicians, I have taken appropriate action on each work order.\n\n\nBest regards,',
    tags: ['Executive Audit', 'Aged Work Orders', 'Management Response', 'Audit Action']
  },
  {
    shortcut: 'pou',
    response: '[ JW-CI ]\n\n I am unable to order a part for the phone as the device is unknown. The technician checked in this customer on my account without specifying the device, hence I cannot proceed with ordering a part for an unknown phone.  ',
    tags: ['Unknown Device', 'Check-In Issue', 'Part Order Block', 'JW-CI']
  },
  {
    shortcut: 'anp',
    response: 'Original Work Order:\nhttps://portal.ubif.net/pos/checkout-new/25381740\n\nIMEI:\n990004843178793\n\n- No payment was taken for diagnostic\n- Out of Pocket Work Order\n- Closing work order until Diagnostic payment is received\n\n- Alex our technician was working with this customer and is no longer employed at this location. The device is not in-store.\n\nAs a result, the work order is being closed out, and the work order status has been marked as declined rfp to maintain accurate record-keeping of ongoing active work orders\n\nconverting work order to lead - adjusting line items for amount paid for due',
    tags: ['Aged Work Order', 'No Payment', 'Former Tech', 'RFP Closeout']
  },
  {
    shortcut: 'emc',
    response: ' Notified the customer via email that their device is available for pickup.  ',
    tags: ['Email Notification', 'Pickup Ready', 'Customer Communication', 'Device Ready']
  },
  {
    shortcut: 'atp',
    response: 'I received the part into our inventory and scanned the part attaching the serial number to the customer\'s work order - work order is ready for repair',
    tags: ['Part Received', 'Inventory', 'Serial Number', 'Ready for Repair']
  },
  {
    shortcut: 'wos',
    response: 'customer called for an update - updated customer on work order status',
    tags: ['Customer Inquiry', 'Call Log', 'Work Order Status', 'Customer Contact']
  },
  {
    shortcut: 'bin',
    response: 'Marking as priority - Moved to BIN UR-4 (Urgent-High Priority) due to work order age',
    tags: ['Priority', 'Urgent', 'Bin Assignment', 'Work Order Age']
  },
  {
    shortcut: 'cpn',
    response: '[ Correcting Previous Note ]\n\n- Diagnostic has been completed\n- Device is in-store\n- Awaiting Device Pickup',
    tags: ['Note Correction', 'Diagnostic Complete', 'In Store', 'Awaiting Pickup']
  },
  {
    shortcut: 'alex',
    response: 'Alex our technician was working with this customer and is no longer employed at this location.\nDevice is not in-store\n\nAs a result, the work order is being closed out, and the work order status has been marked as declined rfp to maintain accurate record-keeping of ongoing active work orders converting work order to lead - adjusting line items for amount paid for due \n\nLead:\n\n',
    tags: ['Former Tech', 'Device Unavailable', 'RFP Closeout', 'Lead Conversion']
  },
  {
    shortcut: 'owo',
    response: 'Original Work Order:\n\n',
    tags: ['Work Order Reference', 'Original Work Order', 'Reference Tag']
  },
  {
    shortcut: 'as',
    response: '(Double Window Time Slot) - WO Aged\nRepair Appointment Set:\n\nAug 15th, 2024 (Scheduled)\n\nTime:\n\n01:30 pm - 02:30 pm (1 hr)\n\n\nSecond Repair Appointment Set:\n\nJul 16th, 2024 (Rescheduled)\n\nTime:\n\n04:30 pm - 06:00 pm (1 hr 30 min)',
    tags: ['Appointment Schedule', 'Double Window', 'Aged WO', 'Repair Appointment']
  },
  {
    shortcut: 'jw',
    response: '[ JW-CI ]',
    tags: ['Check-In', 'JW-CI', 'Staff Tag', 'Initials']
  },
  {
    shortcut: 'eod',
    response: '[ Safe Deposit EOD ]\nEOD excluding check in the drawer for: $\n$100: \n$50: \n$20: \n$10: \n$5: \n$1: \n\n',
    tags: ['EOD', 'Safe Deposit', 'Cash Breakdown', 'Store Closing']
  },
  {
    shortcut: 'sc',
    response: '[ Customer Satisfaction Store Credit ]\n\nStore Credit Explanation: \nDue to unsuccessful repair, customer is getting a store credit of +$$$ to put towards any future repairs or services at our location should the customer decide to return.',
    tags: ['Store Credit', 'Customer Satisfaction', 'Unsuccessful Repair', 'Credit Explanation']
  },
  {
    shortcut: 'cia',
    response: 'Subject: Approval Request (1 hr 30 min)\nClock in for Billable Project: Travel for Communication\nApproval: [Y] Yes / [N] No  ',
    tags: ['Clock In', 'Billable Travel', 'Approval Request', 'Timecard']
  },
  {
    shortcut: 'dsor',
    response: '-----\n\n\n\nDaily Store Operations Report\nDate: August 7, 2024\n\n\n1. Revenue Made for the Day\n   - Revenue Made for the Day: $25\n\n\n2. Staff Behaviors Observed\n   ( Good Behaviors )\n     - Repairing Devices Fast for a New Hire\n     - Asking Relevant Questions about Procedures\n     - Demonstrating Interest in the Location\'s Success\n\n\n3. Focus and Plan for Business Moving Forward\n   - Organize and Maintain a Clean Workspace to Prevent Shrinkage\n   - Limit Inventory Orders to Reduce Shipping Costs\n   - Conduct More Frequent Inventory Counts for Accuracy\n\n\n4. Additional Details\n   - Current Weekly Repair Total: [Pending Update]\n   - Attendance: 0 Tardy Days - 0 Unexcused Absences\n   - BOD (Beginning of Day) & EOD (End of Day) Accuracy: 0-5 of 31 days - 100%\n     - EOD & BOD Match: [Insert Information]\n     - Days Drawer Was Counted: [Insert Information]',
    tags: ['Store Operations', 'Daily Report', 'DSOR', 'Management Report']
  },
  {
    shortcut: 'cru',
    response: 'Customer Repair Update:\n\nParts for the customer\'s device repair were ordered on August 2nd, and we are currently awaiting their arrival. Typically, shipping takes 3-5 business days, and we have not yet received them.\n\nWe understand the urgency for the customer to have their phone back, so I have gone ahead and set a repair appointment date and time and hope the part arrives in time for us to complete the repair before the customer needs to pick up their device before Friday at 2pm, when they will be leaving the state.\n\nCall the customer as soon as the part arrives and the repair is completed.\n\n\n\n\nThank you for your patience, and we will keep you updated on the progress of your repair.  ',
    tags: ['Customer Update', 'Awaiting Parts', 'Urgent Travel', 'Repair Appointment']
  },
  {
    shortcut: 'lnop',
    response: 'Due to the Gainesville location\'s current inventory, they are unable to complete this repair today due to not having the necessary part in stock. Please proceed with the repair for the customer. Thank you for assisting our uBreakiFix customers.',
    tags: ['Inter-Store Transfer', 'Gainesville GA', 'Out of Stock', 'Store Referral']
  },
  {
    shortcut: 'dscp',
    response: 'Difficulty in finding the correct part:\nThe initially ordered part is incorrect, and efforts are being made to locate the correct part but it seems to be difficult to find. \n\nAs for the diagnostic explanation and breakdown of work completed:\n\nThe charge for diagnostic labor encompasses the thorough investigation conducted to pinpoint the underlying cause of the part sourcing issue. This involved verifying the precise specifications of the required part, exploring alternative suppliers, and dedicating time to communicate with vendors while scrutinizing part specifications to guarantee the correct component is obtained. Additionally, the labor invested in disassembling your device to identify the part in need of repair and sourcing, as well as the efforts to install the newly sourced part for troubleshooting, are included in the breakdown of work completed.  ',
    tags: ['Part Sourcing', 'Diagnostic Fee Justification', 'Difficult Part', 'Diagnostic Breakdown']
  },
  {
    shortcut: 'twds',
    response: '[ Technician Workflow & Diagnostic Summary ]\n\nCustomer Report:\n\n     - Phone randomly powers off.\n\n\n\n\nInitial Check-In:\n\n     - Passcode: 122689\n\n     - Find My iPhone: Enabled\n\n     - Cellular Carrier: Spectrum\n\n     - Device Color: Gray\n\n     - Symptoms: Phone randomly powers off\n\n     - Physical Condition: Good\n\n     - Frame Bent: No\n\n     - Previous Repairs: Screen replacement\n\n     - Exposed to Liquid: No\n\n     - Price Quote: $50 for diagnostic\n\n     - Turnaround Time: 1-2 days\n\n     - Preferred Contact: Same number on work order\n\n     - Diagnostic Completed: No\n\n     - Phone Battery Health: Yes\n\n     - Protected by H+: No\n\n\n\n\nDiagnostics & Actions Performed:\n\n    - Connected the device to the charger:\n\n    - Observed that the device stayed powered on without issue while charging.\n\n    - Opened the device to inspect internal components:\n\n    - Cleaned the display flex cable connector pins.\n\n    - Reseated flex cables securely to ensure proper connection.\n\n\n\n\nDiagnostic Findings:\n\n  - After performing initial diagnostics (cleaning and reseating connectors), the phone remained operational without randomly powering off.\n\n  - No apparent hardware failures identified during this phase of diagnostics.\n\n\n\n\n( Explanation of Diagnostic Labor Charge )\n\nDevice Charging Test:\n\n   - Confirming that the issue did not present while the device was connected to the charger.\n\n\n\n Internal Inspection and Maintenance:\n\n   - Time and effort spent opening the device carefully.\n\n   - Cleaning the display flex cable connector pins to ensure proper connectivity.\n\n   - Reseating flex cables for a secure connection, which could address spontaneous power-off issues caused by loose connections.\n\n\n\n Monitoring and Final Testing:\n\n   - Observed the device over a period to ensure stability after performing the adjustments.\n\n\n\n\nNext Steps:\n\n  - Inform the customer that the issue has not recurred during the testing period.\n\n  - Advise that should the problem reoccur, potential next steps involve:\n\n  - Screen replacement.\n\n  - Battery replacement.\n\n  - The issue is currently marked as resolved, but further actions can be taken if needed shortly.',
    tags: ['Technician Workflow', 'Diagnostic Summary', 'Diagnostic Breakdown', 'Power Off Issue']
  },
  {
    shortcut: 'dr',
    response: 'Diagnostic Performed:\n\n\n- Inspected Nintendo Switch game card reader\n\n- Comprehensive diagnostic testing conducted\n\n\n\n\nFindings:\n\n- Game card reader port damaged\n\n- Internal contacts and flex cable connection worn and unreliable\n\n- Consistent game card reading issues\n\n\n\n\nRecommended Repair:\n\n- Replace entire game card reader assembly\n\n- Requires specialized soldering equipment and expertise\n\n\n\n\nIn-Store Repair Limitations:\n\n- In-store technicians lack necessary tools and skills for this repair\n\n- Cannot safely perform intricate soldering work\n\n\n\n\nRepair Escalation:\n\n- Recommend sending Nintendo Switch to uBreakiFix level-3 repair facility\n\n- uBreakiFix technicians can safely remove and replace game card reader\n\n- Estimated 2-3 week turnaround time\n\n- Total repair cost: $129.99\n\n\n\n\nCustomer Considerations:\n\n- Complex repair involving delicate internal soldering\n\n\n\n\nNext Steps:\n\n- Document findings and recommended repair path in work order\n\n- Communicate repair details and timeline to customer\n\n- Arrange for customer to ship device to uBreakiFix repair center  ',
    tags: ['Nintendo Switch', 'Game Card Reader', 'Level-3 Repair', 'Soldering Escalation']
  },
  {
    shortcut: 'dn',
    response: 'write it in a bullet point technician workflow sort of way rewrite this for me and give a proper diagnostic explanation with a good explanation of a breakdown of work completed to this point to help explain the diagnostic labor charge',
    tags: ['Diagnostic Note', 'Technician Prompt', 'Labor Breakdown', 'Workflow']
  },
  {
    shortcut: 'dfc',
    response: 'Difficulty in finding the correct part:\nThe initially ordered part is incorrect and efforts are being made to locate the correct part but it seems to be difficult to find. \n\nAs for the diagnostic explanation and breakdown of work completed:\n\nThe charge for diagnostic labor encompasses the thorough investigation conducted to pinpoint the underlying cause of the part sourcing issue. This involved verifying the precise specifications of the required part, exploring alternative suppliers, and dedicating time to communicate with vendors while scrutinizing part specifications to guarantee the correct component is obtained. Additionally, the labor invested in disassembling your device to identify the part in need of repair and sourcing, as well as the efforts to install the newly sourced part for troubleshooting, are included in the breakdown of work completed.  ',
    tags: ['Part Sourcing', 'Diagnostic Fee Justification', 'Difficult Part', 'Diagnostic Breakdown', 'DFC']
  },
  {
    shortcut: 'wdn',
    response: 'Despite thorough cleaning and assessment, extensive liquid damage has rendered the internal components irreparable without full replacement. The corrosion and moisture have affected critical parts such as the logic board and connectors, creating circuit voltage fluctuations that cannot be restored to working condition.\n\nThe device is being marked unrepairable ready for pickup',
    tags: ['Water Damage', 'Liquid Damage', 'Irreparable', 'Ready for Pickup']
  },
  {
    shortcut: 'pow',
    response: ' The customer paid for diagnostic labor. Upon receiving the device, our technicians opened it up to investigate the issue with the power not functioning. They attempted to reseat the cables and clean the copper on the port in hopes of resolving the power issue, however, these initial steps did not rectify the issue.\n\nAs part of our standard procedure, a diagnostic was necessary to assess whether the device qualified for a UROC Level 3 repair. This diagnostic process involved comprehensive testing and analysis to confirm the specific repair requirements before proceeding with any repairs. Once the diagnostic was completed, the findings were shared with the customer.\n\nDespite the diagnostic results, the customer has opted to decline the repair due to the anticipated repair time involved. The diagnostic labor charge reflects the time, expertise, and resources invested in thoroughly examining the device to identify the root cause of the power issue and determine the necessary repair steps.',
    tags: ['Power Issue', 'Diagnostic Labor Justification', 'UROC Level 3', 'Customer Declined']
  },
  {
    shortcut: 'wop',
    response: 'Parts are available for repair - moving work order to "Awaiting Repair" for accurate record-keeping\n\n- Marking work order as "Priority" due to work order age\nRepair Appointment Set:\n\nJul 31st, 2024 (Rescheduled)\n\nTime:\n\n05:00 pm - 08:00 pm (3 hr)\n\n\n',
    tags: ['Awaiting Repair', 'Priority WO', 'WO Age', 'Repair Appointment']
  },
  {
    shortcut: 'ole',
    response: ' ×Order Limit Error - Items On Order Rejected:\n- on hand inventory indicating max cpaciy and available\n- manufacturer restriant\n- special part order ticket required (multi-day resolution)',
    tags: ['Order Limit Error', 'Inventory Rejected', 'Part Order Exception', 'Manufacturer Restraint']
  },
  {
    shortcut: '!!!',
    response: 'If the customer remains dissatisfied with our service, attempts to resolve their issues, or experiences any service delays they are unsatisfied with, please provide them with this information. Provide escalation level-1 information initially:\n\nOnly provide further escalation steps if the issue remains unresolved, gradually escalating the customer to the next level for a resolution.\n\n(Avoid providing all three escalation levels at once.)\n\nEscalation Level-1:\n\nc.loetz@ubreakifix.com\n\nEscalation Level-2:\n\ngainesvillega@ubreakifix.com\n\nEscalation Level-3\n\nContact uBreakiFix Corporate about complaints via these methods:\n\nEmail: Send an email to support@ubreakifix.com\nPhone: Call uBreakiFix escalation line at (877) 320-2237\nFeedback form: Fill out a feedback form on the uBreakiFix website',
    tags: ['Customer Escalation', 'Management Contacts', 'Corporate Support', 'Level 1-3 Escalation']
  },
  {
    shortcut: '.-',
    response: 'Repair follow up appointment set in repair queue - attaching repair appointment screenshot',
    tags: ['Repair Queue', 'Follow Up Appointment', 'Screenshot Attached', 'Status Note']
  },
  {
    shortcut: '.+',
    response: 'Tracking Update\nhttps://www.ups.com/track?track=yes&trackNums=\n\n\n\nEstimated Time of Arrival:\nMonday, July 08 between 10:15 A.M. - 2:15 P.M. ',
    tags: ['UPS Tracking', 'Tracking Update', 'ETA', 'Shipping']
  },
  {
    shortcut: '.~',
    response: '#881 - Customer Check-in Store Notes:\n\n■ How Did Damage Occur:\n► \n\n■ Passcode:\n► \n\n■ Is Find My iPhone Off:\n► \n\n■ Is device in Repair/Maintenance Mode:\n► \n\n■ Is The Device Backed Up? :\n► \n\n■ Cellular Carrier:\n► \n\n■ Color of Device:\n► \n\n■ Symptoms:\n► \n\n■ Physical Condition:\n► \n\n■ Frame Bent:\n► \n\n■ Previous Repairs:\n► \n\n■ Exposed to Liquid:\n► \n\n■ Price Quote: \n► $\n\n■ Turnaround Time:\n► \n\n■ Preferred Contact:\n► \n\n■ Diagnostic Completed:\n► \n\n■ Phone Battery Health:\n► \n\n■ Protected by H+?:\n► ',
    tags: ['Customer Check-in', 'Store Notes', 'Device Intake Checklist', 'Store #881']
  },
  {
    shortcut: '.jira',
    response: 'Part is currently unavailable via our UBIF Distrobution; attempting to "special order" the part via JIRA\n\ncan not outsource part due for this repair\nattaching part to work order notes\nattaching part link to notes\ngenerating JIRA special order ticket\nattaching JIRA ticket link to notes and maintaining work order in "need to order parts"\n\nPart:\n563403 - GOOGLE PIXEL 8 GLASS/LCD, G949-00927-00\nPart Link:\nhttps://distro.ubif.net/index.php?route=product/product&path=1637_146_3196&product_id=68356\nJIRA Ticket Link:\n\n',
    tags: ['JIRA Special Order', 'UBIF Distribution', 'Part Unavailable', 'Special Order Ticket']
  },
  {
    shortcut: '.spo',
    response: 'CUSTOMER NAME\n[ WO: NUMBER ]\nDEVICE NAME\n- SKU NUMBER - PART NAME AND DESCRIPTION\n\nI am contacting you to seek assistance in procuring the part [PART NAME] for a customer\'s repair. Unfortunately, I couldn\'t find this specific part available for order on UBIF Distro. Your help in obtaining this necessary component would be greatly appreciated',
    tags: ['Special Part Order', 'Procurement Assistance', 'UBIF Distro', 'Part Sourcing']
  },
  {
    shortcut: '.wo',
    response: 'https://portal.ubif.net/pos/workorder/',
    tags: ['UBIF Portal', 'Work Order Link', 'POS Portal', 'Quick Link']
  },
  {
    shortcut: 'ad',
    response: 'Work order is awaiting assigned technician diagnosis',
    tags: ['Awaiting Diagnosis', 'Technician Status', 'Work Order Status', 'Diagnosis Pending']
  },
  {
    shortcut: 'afs',
    response: 'Repair Appointment (Follow Up) Set:\n\nJul 22nd, 2024 (Rescheduled)\n\nTime:\n\n10:30 am - 11:30 am (1 hr)\n\nSetting follow-up appointment for work order as repair appointment has passed - work order is a priority due to age of the active work order - setting follow-up appointment for my next shift to confirm the status of previous repair appointment and determine the technician\'s next steps for the work order moving forward',
    tags: ['Follow Up Appointment', 'Aged WO Priority', 'Rescheduled', 'Shift Hand-Off']
  },
  {
    shortcut: 'ain',
    response: 'Customer Check In Notes\n■ Store Notes (What is the repair situation) :    \n- \n\n\n■ Are there any extra items? :  \n(Games, Cables, Controllers, Stylus, SIM/SD Card etc) \n- No\n- SIM Tray\n- SIM Card\n- Case\n\n\n■ How Did Damage Occur:  \n- impact damage\n- water damage\n- electrical damage (power surge)\n- software corrupted from update or app install\n- randomly started occuring\n\n\n\n■ Passcode : \n- no passcode\n\n\n■ Is Find My iPhone Off :  \n- Yes\n- No, customer will turn it off when they drop off their device when their part comes in\n- No, customer will turn it off when they pick up their device for GSX calibration\n\n\n■ Cellular Carrier :  \n- ATT\n- Verizon\n- T-Mobile\n- Cricket\n- Google\n- Straight Talk\n\n\n■ Color of Device : \n- \n\n\n■ Symptoms :  \n- \n\n\n■ Physical Condition :  \n- bad condition - cracks in the back glass and/or camera lens\n- ok condition - no cracks in the back glass or cracks in the camera lens at first glance\n- good condition - no scratches and the phone is new or like new\n\n\n■ Frame Bent:\n- Frame is not bent\n- Frame is bent and may interfere with successfully completing your repair. The Frame being bent is hindering the disassembly of the phone or the seating process of the new screen.\n\n\n■ Previous Repairs :  \n- no previous repairs\n- yes, previous repairs have been completed via a UBIF location\n- yes, the device has had previous repairs throuh other sources\n\n\n■ Exposed to Liquid :  \n- no corrosion in the charging port and no indication of moisture in the camera lens or in the lcd\n- corrosion in the charging port\n- moisture in the camera lens\n\n\n■ Price Quote:\n- $50 Diagnostic - Repair Deposit due prior to ordering part\n- $ Repair Deposit - Once paid, the part is added to the need to order parts list\n\n\n■ Turnaround Time :  \n- 3-5 Business Days for Shipping\n- 3-5 Days for Diagnostic\n- 3-5 hours for Repair\n- 2-3 hours for Repair\n- 1-2 hours for Repair\n\n\n■ Preferred Contact:\n- \n\n\n■ Diagnostic Completed :  \n- Visual Mechanical Inspection\n\n\n■ Phone Battery Health :  \n- n/a\n\n\n■ Protected by H+?:\n- No\n- Yes',
    tags: ['Customer Intake', 'Check-In Notes', 'Detailed Checklist', 'Intake Options']
  },
  {
    shortcut: 'ap',
    response: 'Parts for this work order have been attempted to be purchased - estimated timeframe for shipping is 3-5 business days - update customer when parts are received - moving work order to "Awaiting Parts"\n\n\nOrder Details\nOrder ID: #\nDate Added: ',
    tags: ['Awaiting Parts', 'Order Details', 'Shipping ETA', 'Part Purchased']
  },
  {
    shortcut: 'ar',
    response: 'Parts are available for repair - moving work order to "Awaiting Repair" for accurate record-keeping',
    tags: ['Awaiting Repair', 'Work Order Status', 'Record Keeping']
  },
  {
    shortcut: 'as',
    response: 'Repair Appointment Set:\n\nJul 16th, 2024 (Rescheduled)\n\nTime:\n\n04:30 pm - 06:00 pm (1 hr 30 min)',
    tags: ['Repair Appointment', 'Appointment Set', 'Rescheduled', 'Schedule Note']
  },
  {
    shortcut: 'cin',
    response: 'Customer Check In Notes\n■ Store Notes (What is the repair situation) :    \n- \n\n\n■ Did You Take a Picture of The Device :  \n- \n \n■ Are there any extra items? :  \n(Games, Cables, Controllers, Stylus, SIM/SD Card etc) \n- \n\n\n■ How Did Damage Occur:  \n- \n\n\n■ Was Multi-Peril approved by the customer or was a reason provided if not ? :  \n- \n\n\n■ Passcode : \n- \n\n\n■ Is The Device Backed Up? : \n- \n\n\n■ Is Find My iPhone Off :  \n- \n\n\n■ Is device in Repair/Maintenance Mode :  \n- \n\n\n■ Cellular Carrier :  \n- \n\n\n■ Color of Device : \n- \n\n\n■ Symptoms :  \n- \n\n\n■ Physical Condition :  \n- \n\n\n■ Are Scratches on the Device :  \n- \n\n\n■ Frame Bent:\n- \n\n\n■ Previous Repairs :  \n- \n\n\n■ Exposed to Liquid :  \n- \n\n\n■ Price Quote:\n- \n\n\n■ Turnaround Time :  \n- \n\n\n■ Preferred Contact:\n- \n\n\n■ Diagnostic Completed :  \n- \n\n\n■ Phone Battery Health :  \n- \n\n\n■ Protected by H+?:\n- ',
    tags: ['Customer Check-in Notes', 'Blank Intake Template', 'Device Intake Checklist', 'Store Intake']
  },
  {
    shortcut: 'dia',
    response: '[ Diagnostic Results ]\n\nSAMSUNG GALAXY S10 PLUS CERAMIC\n\n- Diagnostic Result: (Water Damage/No Power)\n\n- Call the customer and update them on diagnostic results and order parts or let them know if it is unrepairable rfp\n\nRepair (Diagnostic) Appointment Set:\n\nJul 23rd, 2024 (Scheduled)\n\nTime:\n\n03:30 pm - 04:00 pm (30 min)',
    tags: ['Diagnostic Results', 'Water Damage / No Power', 'Customer Call Back', 'Diagnostic Appointment']
  },
  {
    shortcut: 'gcin',
    response: 'Customer Check In Notes\n■ Store Notes (What is the repair situation) :    \n- \n\n\n■ Are there any extra items? :  \n(Games, Cables, Controllers, Stylus, SIM/SD Card etc) \n- No\n- Game\n- Charging Cable\n- Controller\n- SD Card\n\n\n■ How Did Damage Occur:  \n- impact damage\n- water damage\n- electrical damage (power surge)\n- software corrupted from update or app install\n- randomly started occuring\n\n\n■ Color of Device : \n- \n\n\n■ Symptoms :  \n- \n\n\n■ Physical Condition :  \n- \n\n\n■ Frame Bent:\n- Frame is not bent\n- Frame is bent and could potentially be causing issues with other hardware components and create difficulties with being able to complete the repair successfully \n\n\n\n■ Previous Repairs :  \n- no previous repairs\n- yes, previous repairs have been completed via a UBIF location\n- yes, the device has had previous repairs throuh other sources\n\n\n■ Exposed to Liquid :  \n- no corrosion in the power supply, USB, Ethernet or HDMI ports\n- corrosion in the power supply port\n- corrosion in the USB port\n- corrosion in the Ethernet port\n- corrosion in the HDMI port\n\n\n■ Price Quote:\n- $60 Diagnostic - Repair Deposit due prior to ordering part\n- $ Repair Deposit - Once paid, the part is added to the need to order parts list\n\n\n\n■ Turnaround Time :  \n- UROC - 2-3 Week Turn Around Time (14 Business Days)\n- 3-5 Business Days for Shipping\n- 3-5 Days for Diagnostic\n- 2-3 hours for Repair\n\n\n■ Preferred Contact:\n- \n\n\n■ Diagnostic Completed :  \n- Visual Mechanical Inspection\n\n\n■ Protected by H+?:\n- No',
    tags: ['Gaming Console Intake', 'Console Check-In', 'UROC Checklist', 'Store Intake']
  },
  {
    shortcut: 'gin',
    response: 'Customer Check In Notes\n■ Store Notes (What is the repair situation) :    \n- \n\n\n■ Are there any extra items? :  \n(Games, Cables, Controllers, Stylus, SIM/SD Card etc) \n- No\n- SIM Tray\n- SIM Card\n- Case\n\n\n■ How Did Damage Occur:  \n- impact damage\n- water damage\n- electrical damage (power surge)\n- software corrupted from update or app install\n- randomly started occuring\n\n\n■ Passcode : \n- no passcode\n\n\n■ Is The Device Backed Up? : \n- \n\n\n■ Is device in Repair/Maintenance Mode :  \n- yes\n- no\n\n\n■ Cellular Carrier :  \n- ATT\n- Verizon\n- T-Mobile\n- Cricket\n- Google\n- Straight Talk\n\n\n■ Color of Device : \n- \n\n\n■ Symptoms :  \n- \n\n\n■ Physical Condition :  \n- bad condition - cracks in the back glass and/or camera lens\n- ok condition - no cracks in the back glass or cracks in the camera lens at first glance\n- good condition - no scratches and the phone is new or like new\n\n\n■ Frame Bent:\n- Frame is not bent\n- Frame is bent and may interfere with successfully completing your repair. The Frame being bent is hindering the disassembly of the phone or the seating process of the new screen.\n\n\n■ Previous Repairs :  \n- no previous repairs\n- yes, previous repairs have been completed via a UBIF location\n- yes, the device has had previous repairs throuh other sources\n\n\n■ Exposed to Liquid :  \n- no corrosion in the charging port and no indication of moisture in the camera lens or in the lcd\n- corrosion in the charging port\n- moisture in the camera lens\n\n\n■ Price Quote:\n- $50 Diagnostic - Repair Deposit due prior to ordering part\n- $ Repair Deposit - Once paid, the part is added to the need to order parts list\n\n\n■ Turnaround Time :  \n- 3-5 Business Days for Shipping\n- 3-5 Days for Diagnostic\n- 3-5 hours for Repair\n- 2-3 hours for Repair\n- 1-2 hours for Repair\n\n\n■ Preferred Contact:\n- \n\n\n■ Diagnostic Completed :  \n- Visual Mechanical Inspection\n\n\n■ Phone Battery Health :  \n- n/a\n\n\n■ Protected by H+?:\n- Yes\n- No',
    tags: ['Google Pixel Intake', 'Android Intake Notes', 'Device Intake Checklist', 'Store Intake']
  },
  {
    shortcut: 'nop',
    response: 'Part is not in stock and needs to be ordered - moving work order to need to order parts',
    tags: ['Need To Order Parts', 'Part Not In Stock', 'Work Order Status', 'Parts Management']
  },
  {
    shortcut: 'pcin',
    response: 'Customer Check In Notes\n■ Store Notes (What is the repair situation) :    \n- \n\n\n■ Are there any extra items? :  \n(Games, Cables, Controllers, Stylus, SIM/SD Card etc) \n- No\n- Software Disc\n- Game\n- Flash Drive\n- USB adapter\n- WiFi adapter\n- External HDD\n\n\n■ How Did Damage Occur:  \n- impact damage\n- water damage\n- electrical damage (power surge)\n- software corrupted from update or app install\n- randomly started occuring\n\n\n■ Passcode : \n- No passcode\n- Customer can not remember passcode, call the customer when its needed\n\n\n■ Is The Device Backed Up? : \n- \n\n\n■ Color of Device : \n- \n\n\n■ Symptoms :  \n- \n\n\n■ Physical Condition :  \n- \n\n\n■ Frame Bent:\n- Frame is not bent\n- Frame is bent and could potentially be causing issues with other hardware components and create difficulties with being able to complete the repair successfully \n\n\n■ Previous Repairs :  \n- no previous repairs\n- yes, previous repairs have been completed via a UBIF location\n- yes, the device has had previous repairs throuh other sources\n\n\n■ Exposed to Liquid :  \n- no corrosion in the power supply, USB, Ethernet or HDMI ports or in the lcd\n- corrosion in the power supply port\n- corrosion in the USB port\n- corrosion in the Ethernet port\n- corrosion in the HDMI port\n\n\n■ Price Quote:\n- $60 Diagnostic - Repair Deposit due prior to ordering part\n- $ Repair Deposit - Once paid, the part is added to the need to order parts list\n\n\n\n■ Turnaround Time :  \n- UROC - 2-3 Week Turn Around Time (14 Business Days)\n- 3-5 Business Days for Shipping\n- 3-5 Days for Diagnostic\n- 2-3 hours for Repair\n\n\n■ Preferred Contact:\n- \n\n\n■ Diagnostic Completed :  \n- Visual Mechanical Inspection\n\n\n■ Protected by H+?:\n- No',
    tags: ['PC/Laptop Intake', 'Computer Check-In', 'UROC PC Checklist', 'Store Intake']
  },
  {
    shortcut: 'ps',
    response: 'PlayStation Check In Notes\n\n\n\nStore Notes:    \n\n\n\nDoes the device have exterior physical damage? :  \n\n\n\nAre there any extra items? : \n\n(Games, Cables, Controllers, etc) \n\n\n\nDo the HDMI / USB ports have physical damage? Which? : \n\n\n\nDoes the device beep? How many times? :  \n\n\n\nDoes the device power on and stay on?  \n\nIf no, skip next steps :\n\n\n\nDoes the device boot to a white light? :  \n\n\n\nDoes the device display? : \n\n\n\nCan you connect a controller? :  \n\n\n\nDoes the disc drive eject / accept discs? :  \n\n\n\nExtra check-in notes:',
    tags: ['PlayStation Intake', 'Console Check-In', 'PS4 PS5 Intake', 'Diagnostic Checklist']
  },
  {
    shortcut: 'pu',
    response: 'Attempted to order the screen for the customer\'s device but the order was rejected and bounced back due to manufacturers restraint or inventory on hand - checked inventory and did not see any on hand - will try again later:\n\n\n\n ×Order Limit Error\nProduct quantities have been reduced due to DOH restrictions for the following parts:\n- ',
    tags: ['Order Limit Error', 'DOH Restriction', 'Bounced Part Order', 'Manufacturer Restraint']
  },
  {
    shortcut: 'qi',
    response: 'Repair has been completed → moving work order to quality inspection',
    tags: ['Quality Inspection', 'Repair Complete', 'Work Order Status', 'QA Check']
  },
  {
    shortcut: 'raa',
    response: '- (RAA) Repair Appointment Audit \nAs part of the Repair Appointment Audit, I am reviewing today\'s repair appointments to ensure the staffing shifts run smoothly and operations are functioning properly, with the aim to alleviate any work order issues. This work order is included in the repair appointments for today, and I am leaving a note in the work order to provide guidance on how to handle this customer\'s work order. ',
    tags: ['Repair Appointment Audit', 'Shift Management', 'WO Review', 'Operations Audit']
  },
  {
    shortcut: 'ref',
    response: 'For reference, I am attaching a link to an Etsy account charging $55 for a [Repair Service]. We charge $60 for diagnostic labor on non-mobile devices if the device requires check-in, device disassembly, troubleshooting, and sourcing parts for repair. The $60 diagnostic labor charge is non-refundable and is put towards the repair total cost when completed. \n\nRepair labor is $120 per hour, and the customer has been provided an estimated a diagnostic labor charge of $60 but may be charged more depending on how long it takes to complete the repair—estimating 1-2 hours of repair time but aiming for 30 minutes.\n\nReference Link - Repair Seller  ($$$):\nhttps://www.etsy.com/listing/',
    tags: ['Price Reference', 'Labor & Diagnostic Pricing', 'Etsy / Competitor Comparison', 'Customer Pricing Note']
  },
  {
    shortcut: 'rfp',
    response: 'Repair has been completed and is functioning properly → moving work order to RFP and notifying customer their device is ready for pickup',
    tags: ['Ready For Pickup', 'RFP Status', 'Customer Notification', 'Repair Complete']
  },
  {
    shortcut: 'rip',
    response: 'Parts are available for repair - starting repair → moving work order to repair in progress (RIP)',
    tags: ['Repair In Progress', 'RIP Status', 'Parts Available', 'Work Order Status']
  },
  {
    shortcut: 'rw',
    response: '[ Repair Workflow ]\n- Jeremy replaced the top case on the device but the keys were functioning but lifted\n- Jeremy disassembled and saw a screw was pressing on the key and lifting it so he reseated everything the keys were no longer functioning after reseating\n- Swapped the batteries as that is the original repair but the battery was only sourcable with the top casing\n- Used old top casing with new battery and reseated everything and the keyboard is functioning as well as the power but the device is not indicating its charging\n- sound that recognizes cable alerts its connecting but not enough energy is being drawn to power the device\n- Jeremy will be swapping charging ports from new top casing to old top casing\n\nCurrently Repair in Progress - moving work order to proper status',
    tags: ['Repair Workflow', 'Complex Component Swap', 'Technician Work Log', 'MacBook / Laptop Repair']
  },
  {
    shortcut: 'sin',
    response: 'Customer Check In Notes\n■ Store Notes (What is the repair situation) :    \n- \n\n\n■ Are there any extra items? :  \n(Games, Cables, Controllers, Stylus, SIM/SD Card etc) \n- No\n- SIM Tray\n- SIM Card\n- SD Card\n- Stylus\n- Case\n\n\n■ How Did Damage Occur:  \n- impact damage\n- water damage\n- electrical damage (power surge)\n- software corrupted from update or app install\n- randomly started occuring\n\n\n\n■ Passcode : \n- no passcode\n\n\n■ Is The Device Backed Up? : \n- \n\n\n■ Is device in Repair/Maintenance Mode :  \n- yes\n- no\n\n\n■ Cellular Carrier :  \n- ATT\n- Verizon\n- T-Mobile\n- Cricket\n- Google\n- Straight Talk\n\n\n■ Color of Device : \n- \n\n\n■ Symptoms :  \n- \n\n\n■ Physical Condition :  \n- bad condition - cracks in the back glass and/or camera lens\n- ok condition - no cracks in the back glass or cracks in the camera lens at first glance\n- good condition - no scratches and the phone is new or like new\n\n\n■ Frame Bent:\n- Frame is not bent\n- Frame is bent and may interfere with successfully completing your repair. The Frame being bent is hindering the disassembly of the phone or the seating process of the new screen.\n\n\n■ Previous Repairs :  \n- no previous repairs\n- yes, previous repairs have been completed via a UBIF location\n- yes, the device has had previous repairs throuh other sources\n\n\n■ Exposed to Liquid :  \n- no corrosion in the charging port and no indication of moisture in the camera lens or in the lcd\n- corrosion in the charging port\n- moisture in the camera lens\n\n\n■ Price Quote:\n- $50 Diagnostic - Repair Deposit due prior to ordering part\n- $ Repair Deposit - Once paid, the part is added to the need to order parts list\n\n\n■ Turnaround Time :  \n- 3-5 Business Days for Shipping\n- 3-5 Days for Diagnostic\n- 3-5 hours for Repair\n- 2-3 hours for Repair\n- 1-2 hours for Repair\n\n\n■ Preferred Contact:\n- \n\n\n■ Diagnostic Completed :  \n- Visual Mechanical Inspection\n\n\n■ Phone Battery Health :  \n- n/a\n\n\n■ Protected by H+?:\n- Yes\n- No',
    tags: ['Samsung Galaxy Intake', 'Samsung Intake Notes', 'Device Intake Checklist', 'Store Intake']
  },
  {
    shortcut: 'dip',
    response: 'Work order diagnostic has been started → moving work order to diagnostic in progress',
    tags: ['Diagnostic', 'Work Order', 'Diagnostic In Progress']
  },
  {
    shortcut: 'war',
    response: 'WAR: Water Assessment Report\n(Corrosion in Charging Port)\n- Failed\n\n\nThe charging port appears to have a bluish hue and may be corroded. This condition can lead to problems with the motherboard\'s power supply, such as voltage fluctuations. These power supply issues can contribute to the intermittent fading in and out of the device\'s screens or other hardware components, eventually resulting in their complete failure. ',
    tags: ['Water Assessment Report', 'Corrosion in Charging Port', 'Motherboard Power Supply', 'Liquid Damage']
  },
  {
    shortcut: 'woa',
    response: '[ Work Order Audit ]\nI am conducting my weekly work order audits. Please review the checklist below:\n\n■ Proper check-in notes taken?\n- \n■ Passcode obtained?\n- \n■ Find my iPhone disabled?\n- \n■ Correct device checked in?\n- \n■ Device properly marked in-store or out of store?\n- uncertain, im not at the store\n■ Customer\'s repair price quoted properly?\n- \n■ Proper line item SKUs entered for repair?\n- \n■ Correct price entered on line items?\n- \n■ Payment taken for diagnostic labor/repair deposit?\n- \n■ Proper status set for work order? (need to order parts)\n- \n■ Is the work order completed?\n- \nThank you,\nChris',
    tags: ['Work Order Audit', 'Audit Checklist', 'Weekly WO Audit', 'Manager Quality Review']
  },
  {
    shortcut: 'wou',
    response: '[ Work Order Audit: WO Update ]\nI am conducting my weekly work order audits.\n\n\nPlease review the information below for current status, progress, and direction for the current work order. From my review so far and what I have gathered, this is the current status of this work order:\n\nThe Device\n\nThank you,\n\nChris',
    tags: ['Work Order Audit', 'WO Update', 'Weekly Audit Note', 'Manager Direction']
  },
  {
    shortcut: 'status_update',
    response: 'Hi {customer_name}, your uBreakiFix repair ticket #{ticket_id} is currently {status}. Thank you for choosing uBreakiFix!',
    tags: ['Customer Communication']
  },
  {
    shortcut: 'pass_test',
    response: 'Diagnostic test complete: Display, Touchscreen, Battery, Camera, and Speaker passed all quality assurance checks.',
    tags: ['QA', 'Testing']
  },
  {
    shortcut: 'screen_order',
    response: 'Screen replacement part ordered for {device_model}. Estimated arrival: 1-2 business days.',
    tags: ['Parts', 'Inventory']
  }
];

function renderOrgTemplates(filterQuery = '') {
  const container = document.getElementById('orgTemplatesList');
  if (!container) return;

  const countPill = document.getElementById('orgStatTemplateCount');
  if (countPill) countPill.textContent = `📋 ${ubreakifixTemplates.length} Templates`;
  const tabTemplates = document.getElementById('orgTabTemplates');
  const tabAutomations = document.getElementById('orgTabAutomations');
  if (tabTemplates) {
    tabTemplates.textContent = `Templates (${ubreakifixTemplates.length})`;
    tabTemplates.classList.add('active');
  }
  if (tabAutomations) {
    tabAutomations.classList.remove('active');
  }

  const filtered = ubreakifixTemplates.filter(item => {
    return matchesSearch(item.shortcut, item.response, item.tags, filterQuery);
  });

  if (filtered.length === 0) {
    container.innerHTML = `
      <div style="text-align: center; padding: 40px; color: #64748b;">
        <p>No uBreakiFix templates match your search filter.</p>
      </div>
    `;
    return;
  }

  container.innerHTML = filtered.map(item => {
    const isAlreadySaved = !!triggers[item.shortcut];
    const tagsHtml = item.tags.map(t => `<span class="tag-pill" style="font-size: 11px; background: rgba(255, 255, 255, 0.06); padding: 3px 8px; border-radius: 6px; color: #94a3b8;">🏷️ ${t}</span>`).join(' ');

    return `
      <div class="template-card" style="margin-bottom: 12px; background: #141724; border: 1px solid rgba(255,255,255,0.08); border-radius: 16px; padding: 16px;">
        <div class="card-header" style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px;">
          <div style="display: flex; align-items: center; gap: 8px;">
            <span class="trigger-badge" style="background: rgba(157, 255, 0, 0.15); color: #9dff00; font-weight: 800; padding: 4px 10px; border-radius: 8px; font-family: monospace; font-size: 13px;">${item.shortcut}</span>
          </div>
          <button class="btn btn-secondary btn-save-org-template" 
                  data-shortcut="${item.shortcut}" 
                  style="${isAlreadySaved ? 'background: rgba(34, 197, 94, 0.2); color: #22c55e; border-color: #22c55e;' : ''}">
            ${isAlreadySaved ? '✓ Added to account' : '➕ Add to my account'}
          </button>
        </div>
        <div class="card-body" style="font-size: 13px; color: #f1f5f9; background: #0d0f17; padding: 12px; border-radius: 8px; margin-bottom: 10px; white-space: pre-wrap; font-family: inherit;">${item.response}</div>
        <div class="card-footer" style="display: flex; gap: 6px;">
          ${tagsHtml}
        </div>
      </div>
    `;
  }).join('');

  container.querySelectorAll('.btn-save-org-template').forEach(btn => {
    btn.addEventListener('click', () => {
      const shortcut = btn.getAttribute('data-shortcut');
      const tmpl = ubreakifixTemplates.find(t => t.shortcut === shortcut);
      if (tmpl) {
        triggers[shortcut] = {
          enabled: true,
          response: tmpl.response
        };
        saveTriggers();
        renderTriggers();
        renderOrgTemplates(filterQuery);
        alert(`Saved '${shortcut}' to your personal templates collection!`);
      }
    });
  });
}

const ubreakifixAutomations = [
  {
    id: 'ubif_auto_status_sync',
    title: 'Work Order Auto-RFP & Pickup Notification',
    trigger: 'Work Order Status set to RFP (Ready For Pickup)',
    action: 'Send SMS & Email to customer with Portal repair details & pickup hours',
    status: 'Active',
    description: 'Automatically triggers an SMS and Email notification to the customer when a technician updates the work order to Ready For Pickup (RFP).',
    tags: ['WO Status Sync', 'Customer Notification', 'Portal Integration']
  }
];

function renderOrgAutomations() {
  const container = document.getElementById('orgTemplatesList');
  if (!container) return;

  const tabTemplates = document.getElementById('orgTabTemplates');
  const tabAutomations = document.getElementById('orgTabAutomations');
  if (tabTemplates) tabTemplates.classList.remove('active');
  if (tabAutomations) tabAutomations.classList.add('active');

  container.innerHTML = ubreakifixAutomations.map(auto => `
    <div class="template-card" style="margin-bottom: 16px; background: #141724; border: 1px solid rgba(157, 255, 0, 0.2); border-radius: 16px; padding: 20px;">
      <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px;">
        <div style="display: flex; align-items: center; gap: 10px;">
          <span style="font-size: 20px;">⚡</span>
          <div>
            <div style="font-size: 16px; font-weight: 700; color: #ffffff;">${auto.title}</div>
            <div style="font-size: 12px; color: #94a3b8;">Trigger: <strong style="color: #9dff00;">${auto.trigger}</strong></div>
          </div>
        </div>
        <span style="background: rgba(34, 197, 94, 0.15); color: #22c55e; border: 1px solid rgba(34, 197, 94, 0.3); font-weight: 700; font-size: 12px; padding: 4px 10px; border-radius: 20px;">
          ✓ ${auto.status}
        </span>
      </div>
      <div style="font-size: 13px; color: #cbd5e1; background: #0d0f17; padding: 14px; border-radius: 10px; margin-bottom: 12px; line-height: 1.5;">
        ${auto.description}
      </div>
      <div style="display: flex; align-items: center; justify-content: space-between; gap: 8px;">
        <div style="display: flex; gap: 6px;">
          ${auto.tags.map(t => `<span class="tag-pill" style="font-size: 11px; background: rgba(255, 255, 255, 0.06); padding: 3px 8px; border-radius: 6px; color: #94a3b8;">🏷️ ${t}</span>`).join(' ')}
        </div>
        <button class="btn btn-secondary" style="background: rgba(157, 255, 0, 0.1); color: #9dff00; border-color: rgba(157, 255, 0, 0.3);" onclick="alert('This organization workflow automation is active for all uBreakiFix technician accounts!')">
          ⚡ Active Workflow
        </button>
      </div>
    </div>
  `).join('');
}

const orgTabTemplates = document.getElementById('orgTabTemplates');
const orgTabAutomations = document.getElementById('orgTabAutomations');
if (orgTabTemplates && orgTabAutomations) {
  orgTabTemplates.addEventListener('click', () => {
    renderOrgTemplates(document.getElementById('orgSearchInput')?.value || '');
  });

  orgTabAutomations.addEventListener('click', () => {
    renderOrgAutomations();
  });
}

document.getElementById('navHomeBtn')?.addEventListener('click', (e) => {
  e.preventDefault();
  switchView('home');
});

document.getElementById('navOrgUbreakifixBtn')?.addEventListener('click', (e) => {
  e.preventDefault();
  switchView('ubreakifix');
});

document.getElementById('orgSearchInput')?.addEventListener('input', (e) => {
  renderOrgTemplates(e.target.value);
});

const submitOrgModalOverlay = document.getElementById('submitOrgModalOverlay');
const closeSubmitOrgModalBtn = document.getElementById('closeSubmitOrgModalBtn');
const btnCancelSubmitOrg = document.getElementById('btnCancelSubmitOrg');
const btnConfirmSubmitOrg = document.getElementById('btnConfirmSubmitOrg');

function openSubmitOrgModal() {
  if (submitOrgModalOverlay) {
    submitOrgModalOverlay.classList.add('show');
  }
}

function closeSubmitOrgModal() {
  if (submitOrgModalOverlay) {
    submitOrgModalOverlay.classList.remove('show');
  }
}

window.openSubmitOrgModal = openSubmitOrgModal;
window.closeSubmitOrgModal = closeSubmitOrgModal;

submitOrgModalOverlay?.addEventListener('click', (e) => {
  if (e.target === submitOrgModalOverlay) closeSubmitOrgModal();
});

document.getElementById('menuSubmitOrg')?.addEventListener('click', () => {
  helpContextMenu?.classList.remove('show');
  openSubmitOrgModal();
});

closeSubmitOrgModalBtn?.addEventListener('click', closeSubmitOrgModal);
btnCancelSubmitOrg?.addEventListener('click', closeSubmitOrgModal);

btnConfirmSubmitOrg?.addEventListener('click', () => {
  const orgName = document.getElementById('submitOrgName')?.value.trim();
  
  if (!orgName) {
    alert('Please enter your Organization or Company Name.');
    document.getElementById('submitOrgName')?.focus();
    return;
  }

  alert(`Thank you! Your organization submission for "${orgName}" has been received. Our team will review your request and add your organization templates soon.`);
  closeSubmitOrgModal();
  
  if (document.getElementById('submitOrgName')) document.getElementById('submitOrgName').value = '';
  if (document.getElementById('submitOrgEmail')) document.getElementById('submitOrgEmail').value = '';
  if (document.getElementById('submitOrgNotes')) document.getElementById('submitOrgNotes').value = '';
});

const joinOrgModalOverlay = document.getElementById('joinOrgModalOverlay');
const closeJoinOrgModalBtn = document.getElementById('closeJoinOrgModalBtn');
const btnCancelJoinOrg = document.getElementById('btnCancelJoinOrg');
const btnConfirmJoinOrg = document.getElementById('btnConfirmJoinOrg');

function openJoinOrgModal(preselectedOrg = '') {
  if (joinOrgModalOverlay) {
    if (preselectedOrg) {
      const select = document.getElementById('joinOrgSelect');
      if (select) select.value = preselectedOrg;
    }
    joinOrgModalOverlay.classList.add('show');
  }
}

function closeJoinOrgModal() {
  if (joinOrgModalOverlay) {
    joinOrgModalOverlay.classList.remove('show');
  }
}

window.openJoinOrgModal = openJoinOrgModal;
window.closeJoinOrgModal = closeJoinOrgModal;

joinOrgModalOverlay?.addEventListener('click', (e) => {
  if (e.target === joinOrgModalOverlay) closeJoinOrgModal();
});

document.getElementById('menuJoinOrg')?.addEventListener('click', () => {
  helpContextMenu?.classList.remove('show');
  openJoinOrgModal();
});

document.getElementById('btnJoinUbreakifix')?.addEventListener('click', () => {
  openJoinOrgModal('uBreakiFix');
});

closeJoinOrgModalBtn?.addEventListener('click', closeJoinOrgModal);
btnCancelJoinOrg?.addEventListener('click', closeJoinOrgModal);

btnConfirmJoinOrg?.addEventListener('click', () => {
  const orgName = document.getElementById('joinOrgSelect')?.value;
  const workEmail = document.getElementById('joinWorkEmail')?.value.trim();
  const storeLoc = document.getElementById('joinStoreLocation')?.value.trim();
  const role = document.getElementById('joinEmployeeRole')?.value.trim();

  if (!workEmail || !workEmail.includes('@')) {
    alert('Please enter a valid work email address (e.g. alias@organization.com).');
    document.getElementById('joinWorkEmail')?.focus();
    return;
  }

  alert(`Verification request submitted for ${orgName}!\n\nWe sent a confirmation link to ${workEmail}. Please click the link in your email to verify active employment and gain contributor access.`);
  closeJoinOrgModal();

  if (document.getElementById('joinWorkEmail')) document.getElementById('joinWorkEmail').value = '';
  if (document.getElementById('joinStoreLocation')) document.getElementById('joinStoreLocation').value = '';
  if (document.getElementById('joinEmployeeRole')) document.getElementById('joinEmployeeRole').value = '';
});

document.addEventListener('click', (e) => {
  const target = e.target;
  if (!target) return;

  const homeBtn = target.closest('#navHomeBtn');
  if (homeBtn) {
    e.preventDefault();
    switchView('home');
    return;
  }

  const ubreakifixBtn = target.closest('#navOrgUbreakifixBtn');
  if (ubreakifixBtn) {
    e.preventDefault();
    switchView('ubreakifix');
    return;
  }

  const settingsBtn = target.closest('#menuPersonalSettings');
  if (settingsBtn) {
    e.preventDefault();
    const menu = document.getElementById('profileContextMenu');
    if (menu) menu.classList.remove('show');
    switchView('personal_settings');
    return;
  }

  const billingBtn = target.closest('#menuBilling');
  if (billingBtn) {
    e.preventDefault();
    const menu = document.getElementById('profileContextMenu');
    if (menu) menu.classList.remove('show');
    openBillingModal();
    return;
  }

  const importBtn = target.closest('#menuImportTemplates');
  if (importBtn) {
    e.preventDefault();
    const menu = document.getElementById('profileContextMenu');
    if (menu) menu.classList.remove('show');
    document.getElementById('importCsv')?.click();
    return;
  }

  const exportBtn = target.closest('#menuExportTemplates');
  if (exportBtn) {
    e.preventDefault();
    const menu = document.getElementById('profileContextMenu');
    if (menu) menu.classList.remove('show');
    exportToCsv();
    return;
  }

  const signOutBtn = target.closest('#menuSignOut');
  if (signOutBtn) {
    e.preventDefault();
    const menu = document.getElementById('profileContextMenu');
    if (menu) menu.classList.remove('show');
    window.location.href = 'login.html';
    return;
  }

  const joinBtn = target.closest('#btnJoinUbreakifix') || target.closest('#menuJoinOrg');
  if (joinBtn) {
    e.preventDefault();
    const menu = document.getElementById('helpContextMenu');
    if (menu) menu.classList.remove('show');
    openJoinOrgModal(joinBtn.id === 'btnJoinUbreakifix' ? 'uBreakiFix' : '');
    return;
  }

  const submitBtn = target.closest('#menuSubmitOrg');
  if (submitBtn) {
    e.preventDefault();
    const menu = document.getElementById('helpContextMenu');
    if (menu) menu.classList.remove('show');
    openSubmitOrgModal();
    return;
  }

  const supportBtn = target.closest('#menuGetSupport') || target.closest('#menuFeedback');
  if (supportBtn) {
    e.preventDefault();
    const menu = document.getElementById('helpContextMenu');
    if (menu) menu.classList.remove('show');
    alert('Thank you for contacting TypeSmart Support! You can reach us directly at support@typesmart.app.');
    return;
  }
});
